import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Paper,
  Box,
  Tabs,
  Tab,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
  Button,
  Typography,
  Grid,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  IconButton,
  FormGroup,
  FormLabel,
  FormControl,
  Select,
  DialogTitle,
  alpha,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import "./mywallet.css";
import send from "../../Assets/Images/send.png";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import WalletGraph from "./WalletGraph";
import { useSelector } from "react-redux";
import axios from "axios";
import QRCode from "react-qr-code";
import {
  showToast,
  showErrorDialog,
  WEBSERVICE,
  checkCurrencyAccreditedStatus,
} from "../../CoreDataService";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { set, useForm } from "react-hook-form";
import { ERCCURRENCY, countries } from "../constants";
import { OnlyAllowedInput, OnlyAllowedZipCode } from "../IdentityVerification";
import { use } from "react";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import CallMadeIcon from "@mui/icons-material/CallMade";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ModalContent from "../../Common/Modal";
import InfoPopUp from "../../Common/InfoPopUp";
import DataTable from "../../Common/DataTable";
import { ContainedButton } from "../../Common/Buttons";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AccreditationVerificationPopup from "../Accredited-Kyc/AccreditationVerificationPopup";
import PabtekPaymentPopup from "../../Common/PabtekPaymentPopup";

const columns = [
  "Asset",
  "Price",
  "Change",
  "Available Balance",
  "Holdings",
  "Holdings",
  "Send",
  "Receive",
  "Buy",
];

const TransuctionHistoryColumn = [
  "TimeStamp",
  "Description",
  "Asset",
  "Amount",
  "Action",
  "Status",
  "Travel Rule info",
];

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 573,
  width: "90%",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 2,
  overflow: "auto",
  // Hide scrollbar
  scrollbarWidth: "none", // Firefox
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "start",
  borderBottom: "2px solid #616266",
  padding: "16px",
};

const bodyStyle = {
  padding: "16px",
  textAlign: "left",
};

const addressOptionsSend = {
  HCX: [
    {
      label: "HCX NATIVE",
      handlerKey: "NATIVE",
      message: "Do you want to send HCX NATIVE ?",
    },
    {
      label: "HCX ERC",
      handlerKey: "ERC",
      message: "Do you want to send HCX ERC ?",
    },
  ],
  USDT: [
    {
      label: "USDT ERC",
      handlerKey: "ERC",
      message: "Do you want to send USDT ERC ?",
    },
    {
      label: "USDT TRC",
      handlerKey: "TRC",
      message: "Do you want to send USDT TRC ?",
    },
    {
      label: "USDT POL",
      handlerKey: "POL",
      message: "Do you want to send USDT POL ?",
    },
    {
      label: "USDT BSC",
      handlerKey: "BEP",
      message: "Do you want to send USDT BEP ?",
    },
  ],
};
const addressOptions = {
  HCX: [
    {
      label: "HCX NATIVE ADDRESS",
      handlerKey: "NATIVE",
      message: "Do you want to generate HCX NATIVE Address?",
    },
    {
      label: "HCX ERC ADDRESS",
      handlerKey: "ERC",
      message: "Do you want to generate HCX ERC Address?",
    },
  ],
  USDT: [
    {
      label: "USDT ERC ADDRESS",
      handlerKey: "ERC",
      message: "Do you want to generate USDT ERC Address?",
    },
    {
      label: "USDT TRC ADDRESS",
      handlerKey: "TRC",
      message: "Do you want to generate USDT TRC Address?",
    },
    {
      label: "USDT POL ADDRESS",
      handlerKey: "POL",
      message: "Do you want to generate USDT POL Address?",
    },
    {
      label: "USDT BSC ADDRESS",
      handlerKey: "BEP",
      message: "Do you want to generate USDT BEP Address?",
    },
  ],
};

const MyWalletSpot = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    watch,
  } = useForm();
  const themeColor = localStorage.getItem("theme");
  const { brokerBasicInfo, userInfo, btncolor, allColors } = useSelector(
    (state) => state
  );
  const userCountry = localStorage.getItem("userCountry");

  const MOONPAY_SUPPORTED_CURRENCIES = [
    "UNI",
    "SOL",
    "XLM",
    "USDC",
    "GRT",
    "TRX",
    "BAT",
    "LTC",
    "LINK",
    "XRP",
    "ETH",
    "DAI",
    "TON",
  ];

  const countryList = countries;
  const [activeButton, setActiveButton] = useState("send");
  const [withdrawlCurrencyModal, setWithdrawlCurrencyModal] = useState(false);
  const [depositeCurrencyModal, setDepositeCurrencyModal] = useState(false);
  const [sendModal, setSendModal] = useState(false);
  const [depositeModal, setDepositeModal] = useState(false);
  const [sendTab, setsendTab] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [countryFlag, setCountryFlag] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchCoin, setSearchCoin] = useState("");
  const moonPayBalanceIntervalRef = useRef(null);
  const [filteredCountries, setFilterCountry] = useState([]);
  const [myBalanceList, setMyBalanceList] = useState([]);
  const [myBalanceListOriginal, setMyBalanceListOriginal] = useState([]);
  const [fiatRateArray, setFiatRateArray] = useState([]);
  const [infoModal, setInfoModal] = useState(false);
  const [infoIndex, setInfoIndex] = useState(0);
  const [currencyCode, setCurrencyCode] = useState("");
  const [currencyMiddleModal, setCurrencyMiddleModal] = useState(false);
  const [currencyMiddleSendModal, setCurrencyMiddleSendModal] = useState(false);
  const [tokentype, setTokenType] = useState("");
  const [tokentypeinitial, setTokenTypeInitial] = useState("");
  const [toggle, setToggle] = useState(false);

  const [whistoryDetails, setWhistoryDetails] = useState([]);
  const [whistoryDetails1, setWhistoryDetails1] = useState([]);
  const [currentPageData, setCurrentPageData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pgn, setPgn] = useState(1);
  const [transactionType, setTransactionType] = useState("send"); // Set this accordingly
  const [maxDisable, setMaxDisable] = useState(false);
  const [maxExAmount, setMaxExAmount] = useState(0);
  const [maxWalletAmount, setMaxWalletAmount] = useState(0);
  const [
    withdrawWhiteEnableDisableStatus,
    setWithdrawWhiteEnableDisableStatus,
  ] = useState(0);
  const [error, setError] = useState(null);

  const [sendTowalletButtonStatus, setSendTowalletButtonStatus] =
    useState(null);
  const [sendErrorMessage, setSendErrorMessage] = useState("");
  const [validmsg, setValidmsg] = useState(null);
  const [errormsg, setErrormsg] = useState("");
  const [cryptoCurrency, setCryptoCurrency] = useState("");
  const [currencyFullName, setCurrencyFullName] = useState("");
  const [balance, setBalance] = useState(0);
  const [miningFees, setMiningFees] = useState(0);
  const [currencyId, setCurrencyId] = useState("");

  // ── Buy with Card (Pabtek) popup ──────────────────────────
  const [pabtekPopupOpen, setPabtekPopupOpen] = useState(false);
  const [pabtekCurrency, setPabtekCurrency] = useState({ id: "", code: "" });

  const [networkfee, setNetworkfee] = useState("");
  const [gstCharge, setGstCharge] = useState(0);
  const [tdsCharge, setTdsCharge] = useState(0);
  const [gstRate, setGstRate] = useState(0);
  const [tdsRate, setTdsRate] = useState(0);
  const [otherWalletMinValue, setOtherWalletMinValue] = useState(null);
  const [otherWalletMiningFees, setOtherWalletMiningFees] = useState(null);
  const [curPrecision, setCurPrecision] = useState(null);

  const [authModalOpen, setAuthModalOpen] = useState(false);

  const [emailOtp, setEmailOtp] = useState("");
  const [twoFactorOtp, setTwoFactorOtp] = useState("");
  const [isConfirmLoading, setIsConfirmLoading] = useState(false);
  const [isGetCodeButtonDisabled, setIsGetCodeButtonDisabled] = useState(false);
  const [messageotp, setMessageOtp] = useState("");

  const [errorMsg, setErrorMsg] = useState("");
  const [networkFee, setNetworkFee] = useState("");

  const [paybitoAmount, setPaybitoAmount] = useState("");
  const [otherAmount, setOtherAmount] = useState("");

  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  const [maxSendAmount, setMaxSendAmount] = useState(0);

  const [lockOutgoingTransactionStatus, setLockOutgoingTransactionStatus] =
    useState(0); // Assuming initial value 0
  const [twoFactorOtpOnly, setTwoFactorOtpOnly] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [paybitoPhone, setPaybitoPhone] = useState("");

  const [userBalanceList, setUserBalanceList] = useState([]);
  const [fiatCurrencyList, setFiatCurrencyList] = useState([]);
  const [usdbalance, setUsdbalance] = useState(null);
  const [sgdbalance, setSgdbalance] = useState(null);
  const [eurbalance, setEurbalance] = useState(null);
  const [aedbalance, setAedbalance] = useState(null);
  const [inrbalance, setInrbalance] = useState(null);
  const [gbpbalance, setGbpbalance] = useState(null);
  const [selectedCryptoCurrency, setSelectedCryptoCurrency] = useState(null);

  const [recipientName, setRecipientName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [cryptoEmailAddress, setCryptoEmailAddress] = useState("");
  const [cryptoEmailAddressRcv, setCryptoEmailAddressRcv] = useState("");
  const [recipientNameRcv, setRecipientNameRcv] = useState("");
  const [accountNumberRcv, setAccountNumberRcv] = useState("");
  const [questionModal, setShowQuestionModal] = useState(false);
  const [questionModalRecieve, setShowQuestionModalRecieve] = useState(false);
  const [showMobileNumberInfo, setMobileNumberInfo] = useState(false);
  const [showEnternalWalletInfo, setEnternalWalletInfo] = useState(false);
  const [showWalletTnxHModal, setWalletTnxHModal] = useState(false);
  const [cryptoRcvTrnId, setCryptoRcvTrnId] = useState(null);
  const [cryptoFirmRcv, setCryptoFirmRcv] = useState("");

  const [rcv, setRcv] = useState(null);
  const [coinTag, setCoinTag] = useState(null);
  const [timer, setTimer] = useState(false);
  const [emailOtpTime, setEmailOtpTime] = useState(0);

  const [whitelistAddressDetailsList, setWhitelistAddressDetailsList] =
    useState([]);

  const [selectedAddressOption, setSelectedAddressOption] =
    useState("Enter Address");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [homeCurrency, setHomeCurrency] = useState("");

  const [txnCharge, setTxnCharge] = useState("");
  const [maxValueCoin, setMaxValueCoin] = useState("");
  const [minValueCoin, setMinValueCoin] = useState("");
  const [sendDisclaimerCoin, setSendDisclaimerCoin] = useState("");

  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [recipientFirstName, setRecipientFirstName] = useState("");
  const [recipientLastName, setRecipientLastName] = useState("");
  const [individualCheck, setIndividualCheck] = useState(false);
  const [companyCheck, setCompanyCheck] = useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(true);
  const [ownAccount, setOwnAccount] = useState(false);
  const [ownAccountRcv, setOwnAccountRcv] = useState(false);
  const [companyFlag, setCompanyFlag] = useState(false);
  const [individualFlag, setIndividualFlag] = useState(false);
  const [addressFlag, setAddressFlag] = useState(false);
  const [idNumberVal, setIdNumberVal] = useState(false);

  const [entityStatus, setEntityStatus] = useState(0);
  const itemsPerPage = 10;
  const pageCount = Math.ceil(whistoryDetails1.length / itemsPerPage);

  const [recipientFirstNameRcv, setRecipientFirstNameRcv] = useState("");
  const [recipientLastNameRcv, setRecipientLastNameRcv] = useState("");
  const [houseNoVal, setHouseNoVal] = useState("");
  const [streetVal, setStreetVal] = useState("");
  const [cityVal, setCityVal] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [countryVal, setCountryVal] = useState("");
  const [zipVal, setZipVal] = useState("");
  const [passportVal, setPassportVal] = useState("");
  const [indDobVal, setIndDobVal] = useState("");
  const [indPobVal, setIndPobVal] = useState("");
  const [comIdNum, setComIdNum] = useState("");
  const [bsnsLoc, setBsnsLoc] = useState("");

  const [individualCheckRcv, setIndividualCheckRcv] = useState(false);
  const [companyCheckRcv, setCompanyCheckRcv] = useState(false);

  const [passportFlag, setPassportFlag] = useState(false);
  const [birthFlag, setBirthFlag] = useState(false);
  const [originatorval, setOriginatorval] = useState(false);

  const [providedDetailsStatus, setProvidedDetailsStatus] = useState(0);
  const [warningPopupSendModal, setWarningPopupSendModal] = useState(false);
  const [warningPopupModal, setWarningPopupModal] = useState(false);
  const [warningPopupGenModal, setWarningPopupGenModal] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [isTravelData, setIsTravelData] = useState("");
  const [memoRequired, setMemoreRequired] = useState(0);

  const [rcvButtonStatus, setRcvButtonStatus] = useState(false);
  const [sendDone, setSendDone] = useState(false);
  const [rcvDone, setRcvDone] = useState(false);
  const [sendTransactions, setSendTransactions] = useState([]);
  const [rcvTransactions, setRcvTransactions] = useState([]);
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [payWalletModal, setPayWalletModal] = useState(false);
  const [payLoading, setPayLoading] = useState(false);
  const [invoicePayData, setInvoicePayData] = useState(null);

  const isHCX = cryptoCurrency === "HCX";
  const showERC = ["USDT", "MATIC"].includes(cryptoCurrency);

  console.log("payWalletModal", payWalletModal);

  const Infomodal = [
    {
      title: "Asset",
      description: `This column displays the name of currencies listed in ${brokerBasicInfo?.companyName} exchange.`,
    },
    {
      title: "Price",
      description: `This column displays the price of a particular currency with respect to ${homeCurrency}`,
    },
    {
      title: "Change",
      description:
        "This column displays the price change of a currency within 24 hours.",
    },
    {
      title: "",
      description: "",
    },
    {
      title: "Holdings",
      description: "Holdings displays the balance of a particular currency.",
    },
    {
      title: `Holdings (${currencySymbol})`,
      description: `Holdings (${currencySymbol}) displays the balance of a currency in ${homeCurrency} (${currencySymbol}).`,
    },
    {
      title: "SEND",
      description: "Users can withdraw fiat and crypto from here.",
    },
    {
      title: "RECEIVE",
      description: "Users can Deposit fiat and crypto from here.",
    },
    {
      title: "PORTFOLIO GRAPH",
      description:
        "Displays portfolio holdings in dollars of particular customer within 1 day, 1 month, 3 months, 6 months, and 1 year.",
    },
    {
      title: "SEND",
      description: "Send displays the send operation details.",
    },
    {
      title: "RECEIVE",
      description: "Receive displays the receive operation details.",
    },
  ];
  const contentStyle = {
    bgcolor: themeColor === "dark" ? "#273338" : "#fff",
    color: themeColor === "dark" ? "white" : "black",
    textAlign: "center",
    mx: "auto",
    my: "10vh",
    width: { xs: "90%", sm: 538 },
    borderRadius: 2,
    boxShadow: "0 0 60px 30px #fff,0 0 100px 60px #f0f,0 0 140px 90px #0ff",
    outline: "none",
  };

  const theme = createTheme({
    components: {
      MuiPaginationItem: {
        styleOverrides: {
          root: {
            color: "#ccc",
            backgroundColor: btncolor,
            borderRadius: 6,
            margin: "0 2px",
            border: "1px solid #19747E",
            "&.Mui-selected": {
              backgroundColor: btncolor,
              color: "#000",
            },
            "&:hover": {
              backgroundColor: btncolor,
            },
          },
          previousNext: {
            backgroundColor: btncolor,
            "&.Mui-selected": {
              backgroundColor: btncolor,
              color: "#000",
            },
          },
          ellipsis: {
            color: "#ccc",
          },
        },
      },
    },
  });

  useEffect(() => {
    const minFee = otherWalletMinValue || 0;
    const feeRate = ((balance - minFee) * otherWalletMiningFees) / 100;
    const gst = (minFee + feeRate) * (gstRate / 100);
    const tds = (balance - (minFee + feeRate + gst)) * (tdsRate / 100);
    console.log("otherWalletMinValue", otherWalletMinValue, balance, tds);
    const calculatedExMax = balance
      ? (balance - (minFee + feeRate + gst + tds)).toFixed(curPrecision)
      : balance;
    const calculatedMaxWallet = balance
      ? (balance - tds).toFixed(curPrecision)
      : balance;
    setMaxExAmount(Number(calculatedExMax));
    setMaxWalletAmount(Number(calculatedMaxWallet));
  }, [otherWalletMinValue, balance]);

  const submitQuestions = async (e) => {
    e.preventDefault();

    if (
      recipientFirstName === "" ||
      // recipientFirstName === undefined ||
      recipientLastName === "" ||
      recipientLastName === undefined ||
      accountNumber === "" ||
      accountNumber === undefined ||
      cryptoEmailAddress === "" ||
      cryptoEmailAddress === undefined
    ) {
      showToast("error", "Please add all fields");
      return;
    }

    let entityStatusLocal = individualCheck ? 1 : 2;
    setEntityStatus(entityStatusLocal);

    const inputObj = {
      transactionId: cryptoRcvTrnId,
      uuid: localStorage.getItem("uuid"),
      name: `${recipientFirstName} ${recipientLastName}`,
      accountId: accountNumber,
      firmEmail: cryptoEmailAddress,
      accountType: entityStatusLocal,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/saveUserTravelData`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.error.error_data === 0) {
        showToast(
          "success",
          "This information will be reviewed by our team to process the withdrawal. View the status of your withdrawal in the Wallet Transaction History section on this page."
        );
        walletHistoryList("1", transactionType);
      } else {
        showToast("error", response.data.error.error_msg);
      }

      setShowQuestionModal(false); // Replace with your modal close logic
    } catch (err) {
      showToast("error", "Something went wrong");
    }
  };

  const ownAccountCheck = (e) => {
    const data = e.target.checked;
    setOwnAccount(data);
    const { userResult } = userInfo;
    // setIndividualCheck(false);
    // setCompanyCheck(false);

    if (data === true) {
      setRecipientFirstName(userResult?.firstName);
      setRecipientLastName(userResult?.lastName);

      if (userResult?.userType === 1) {
        setIndividualCheck(true);
        setCompanyCheck(false);
      } else {
        setIndividualCheck(false);
        setCompanyCheck(true);
      }
    } else {
      setRecipientFirstName("");
      setRecipientLastName("");
    }
  };

  const ownAccountCheckRcv = (e) => {
    const data = e.target.checked;
    setOwnAccountRcv(data);
    const { userResult } = userInfo;

    // Reset some states
    // setIndividualCheckRcv(false);
    // setCompanyCheckRcv(false);

    if (data === true) {
      setRecipientFirstNameRcv(userResult?.firstName);
      setRecipientLastNameRcv(userResult?.lastName);

      if (userResult?.userType === 1) {
        setIndividualCheckRcv(true);
        setCompanyCheckRcv(false);
        setAddressFlag(true);
        setIdNumberVal(false);
        setCompanyFlag(false);
        setIndividualFlag(true);
      } else {
        setIndividualCheckRcv(false);
        setCompanyCheckRcv(true);
        setAddressFlag(false);
        setIdNumberVal(true);
        setCompanyFlag(true);
        setIndividualFlag(false);
      }
    } else {
      setRecipientFirstNameRcv("");
      setRecipientLastNameRcv("");

      if (userResult?.userType === 1) {
        setIndividualCheckRcv(true);
        setCompanyCheckRcv(false);
        setAddressFlag(true);
        setIdNumberVal(false);
        setCompanyFlag(false);
        setIndividualFlag(true);
      } else {
        setIndividualCheckRcv(false);
        setCompanyCheckRcv(true);
        setAddressFlag(false);
        setIdNumberVal(true);
        setCompanyFlag(true);
        setIndividualFlag(false);
      }
    }
  };

  const checkBoxText = () => {
    let text = "";
    if (individualCheck) {
      text = "Full name, National ID number";
    } else {
      if (companyCheck) {
        text =
          "Enterprise entity legal name, Principal place of business as registered on the originating exchange or wallet";
      }
    }
    return text;
  };

  console.log("memoRequired", memoRequired);

  const selctKycUserType = (e) => {
    const data = e.target.value;
    console.log("data", data);
    setIndividualCheck(data === "Individual");
    setCompanyCheck(data === "Company");

    if (data === "Individual") {
      setCompanyFlag(false);
      setIndividualFlag(true);
      setAddressFlag(true);
      setIdNumberVal(false);
    } else {
      setIndividualFlag(false);
      setCompanyFlag(true);
      setAddressFlag(false);
      setIdNumberVal(true);
    }
  };
  const selctKycUserTypeRcv = (e) => {
    const data = e.target.value;
    console.log("data", data);
    setIndividualCheckRcv(data === "Individual");
    setCompanyCheckRcv(data === "Company");

    if (data === "Individual") {
      setCompanyFlag(false);
      setIndividualFlag(true);
      setAddressFlag(true);
      setIdNumberVal(false);
    } else {
      setIndividualFlag(false);
      setCompanyFlag(true);
      setAddressFlag(false);
      setIdNumberVal(true);
    }
  };

  const termsCheck = (e) => {
    setIsTermsChecked(!e.target.checked);
    // Your logic here
  };

  const changeUserProvide = (e) => {
    console.log(e.target.value);
    const data = e.target.value;

    if (data === "addr") {
      setAddressFlag(true);
      setPassportFlag(false);
      setBirthFlag(false);

      setIdNumberVal(false);
      setOriginatorval(false);

      setProvidedDetailsStatus(1);
    } else if (data === "passport") {
      setPassportFlag(true);
      setAddressFlag(false);
      setBirthFlag(false);

      setIdNumberVal(false);
      setOriginatorval(false);

      setProvidedDetailsStatus(2);
    } else {
      setAddressFlag(false);
      setPassportFlag(false);
      setBirthFlag(true);

      setIdNumberVal(false);
      setOriginatorval(false);

      setProvidedDetailsStatus(3);
    }
  };

  const changeUserProvideEnt = (e) => {
    const data = e.target.value;

    if (data === "idNumber") {
      setIdNumberVal(true);
      setOriginatorval(false);
      setAddressFlag(false);
      setBirthFlag(false);
      setPassportFlag(false);
      setProvidedDetailsStatus(4);
    } else if (data === "originator") {
      setIdNumberVal(false);
      setOriginatorval(true);
      setAddressFlag(false);
      setBirthFlag(false);
      setPassportFlag(false);
      setProvidedDetailsStatus(5);
    }
  };

  const termsCheckRcv = (e) => {
    const data = e.target.checked;

    if (data === true) {
      setRcvButtonStatus(false);
    } else {
      setRcvButtonStatus(true);
    }
  };

  const submitQuestionsRcv = () => {
    if (
      recipientFirstNameRcv === "" ||
      recipientFirstNameRcv === undefined ||
      // recipientLastNameRcv === "" ||
      // recipientLastNameRcv === undefined ||
      accountNumberRcv === "" ||
      accountNumberRcv === undefined ||
      cryptoFirmRcv === "" ||
      cryptoFirmRcv === undefined
    ) {
      showToast("error", "Please add all fields");
      return;
    }

    let inputObj = {};
    const entityStatus = individualCheckRcv ? 1 : 2;

    inputObj.transactionId = cryptoRcvTrnId;
    inputObj.uuid = localStorage.getItem("uuid");
    inputObj.name = `${recipientFirstNameRcv} ${recipientLastNameRcv}`;
    inputObj.accountId = accountNumberRcv;
    inputObj.firmEmail = cryptoFirmRcv;
    inputObj.accountType = entityStatus;

    if (addressFlag) {
      inputObj.uniqueId = `${houseNoVal},${streetVal},${cityVal},${stateVal},${countryVal},${zipVal}`;
      inputObj.uniqueIdType = "Address";
    }
    if (passportFlag) {
      inputObj.uniqueId = passportVal;
      inputObj.uniqueIdType = "National Id";
    }
    if (birthFlag) {
      inputObj.uniqueId = `${indDobVal},${indPobVal}`;
      inputObj.uniqueIdType = "DOB";
    }
    if (idNumberVal) {
      inputObj.uniqueId = comIdNum;
      inputObj.uniqueIdType = "Company Id";
    }
    if (originatorval) {
      inputObj.uniqueId = bsnsLoc;
      inputObj.uniqueIdType = "Business Location";
    }

    axios
      .post(`${WEBSERVICE}transaction/saveUserTravelData`, inputObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      })
      .then((response) => {
        if (response.data.error.error_data === 0) {
          showToast(
            "success",
            "This information will be reviewed by our team to process the deposit. View the status of your deposit in the Wallet Transaction History section on this page."
          );
          walletHistoryList("1", transactionType);
        } else {
          showToast("error", response.data.error.error_msg);
        }
        setShowQuestionModalRecieve(false);
      })
      .catch((error) => {
        showToast("error", "Something went wrong. Please try again.");
        setShowQuestionModalRecieve(false);
      });
  };

  const handleCloseAuthModal = () => (
    setAuthModalOpen(false),
    setEmailOtpTime(0),
    setTimer(false),
    setTwoFactorOtp(""),
    setEmailOtp(""),
    setIsConfirmLoading(false)
  );

  const handleConfirm = async () => {
    if (isConfirmLoading) return;
    setIsConfirmLoading(true);
    try {
      if (sendTab === `${brokerBasicInfo?.companyName} WALLET`) {
        await transactionSendWithinPaybito();
      } else {
        await transactionSendForOthers();
      }
    } finally {
      setIsConfirmLoading(false);
    }
  };

  useEffect(() => {
    const { userResult } = userInfo;
    if (userResult) {
      if (userResult?.userType === 1) {
        setIndividualCheckRcv(true);
        setCompanyCheckRcv(false);
        setIndividualCheck(true);
        setCompanyCheck(false);
      } else {
        setIndividualCheckRcv(false);
        setCompanyCheckRcv(true);
        setIndividualCheck(false);
        setCompanyCheck(true);
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (authModalOpen && timer) {
      if (emailOtpTime > 0) {
        const countdown = setInterval(() => {
          setEmailOtpTime((prevCountdown) => prevCountdown - 1);
        }, 1000);
        return () => clearInterval(countdown);
      } else {
        setTimer(false);
      }
    }
  }, [emailOtpTime]);

  useEffect(() => {
    if (emailOtp.length === 8 && twoFactorOtp.length === 6 && authModalOpen) {
      handleConfirm();
    }
  }, [emailOtp, twoFactorOtp]);

  useEffect(() => {
    setCurrencySymbol(localStorage.getItem("homeCurrencySymbol"));
    setHomeCurrency(localStorage.getItem("homeCurrency"));
    walletHistoryList("1", "send");
    (async () => {
      await showTravelData("send");
      await showTravelData("received");
    })();
  }, []);
  useEffect(() => {
    if (sendTab === "External Address") {
      getAllAddressList();
    }
  }, [sendTab]);
  useEffect(() => {
    setsendTab(`${brokerBasicInfo?.companyName} WALLET`);
  }, [brokerBasicInfo]);

  useEffect(() => {
    if (sendDone && rcvDone) {
      const filteredWithdraw = sendTransactions.filter(
        (x) =>
          (x.isTravelData === 0 || x.isTravelData === 3) &&
          x.action === "Send" &&
          x.sendReceiveType === "o"
      );

      const filteredRcv = rcvTransactions.filter(
        (x) =>
          (x.isTravelData === 0 || x.isTravelData === 3) &&
          x.action === "Received" &&
          x.sendReceiveType === "o"
      );
      showWarningPopupSendRcv(filteredWithdraw, filteredRcv);
    }
  }, [sendDone, rcvDone]);
  const showWarningPopupSendRcv = (filteredWithdraw, filteredRcv) => {
    if (!showWarning) {
      if (filteredWithdraw.length !== 0 && filteredRcv.length !== 0) {
        setWarningPopupGenModal(true);
        setShowWarning(true);
      } else if (filteredWithdraw.length !== 0 && filteredRcv.length === 0) {
        setWarningPopupModal(true);
        setShowWarning(true);
      } else if (filteredWithdraw.length === 0 && filteredRcv.length !== 0) {
        setWarningPopupSendModal(true);
        setShowWarning(true);
      }
    }
  };

  const handleCloseMiddleModal = () => setCurrencyMiddleModal(false);
  const handleCloseMiddleSendModal = () => setCurrencyMiddleSendModal(false);

  const handleWalletPayment = async () => {
    try {
      setPayLoading(true);
      const storedInvoice =
        invoicePayData ||
        JSON.parse(localStorage.getItem("invoicePayData") || "{}");
      const payload = {
        uuid: localStorage.getItem("uuid"),
        userId: Number(localStorage.getItem("userId")),
        sendAmount: Number(storedInvoice.amount_to_be_paid || balance),
        invoiceId: Number(storedInvoice.invoice_id) || 0,
      };
      const response = await axios.post(
        `${WEBSERVICE}transaction/exchange-wallet-payment-checkout`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.error.error_data === 0) {
        showToast(
          "success",
          response.data.error.error_msg || "Payment successful"
        );
        localStorage.removeItem("invoicePayData");
        setInvoicePayData(null);
        setPayWalletModal(false);
      } else {
        showToast("error", response.data.error.error_msg);
      }
    } catch (err) {
      showToast("error", "Something went wrong");
    } finally {
      setPayLoading(false);
    }
  };

  const options = addressOptions[currencyCode] || [];
  const optionsSend = addressOptionsSend[currencyCode] || [];

  const handleAddressOptionChange = (event) => {
    setSelectedAddressOption(event.target.value);
    setValue("externalInputAddress", "");
    setValue("externalSelectAddress", "");
    setValue("externalAmount", "");
    setValue("externalAmount", "");
  };

  const handlePageChange = (event, value) => {
    console.log("pageno", value);
    setPgn(value);

    const startIndex = (value - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const paginatedData = whistoryDetails1?.slice(startIndex, endIndex);
    setCurrentPageData(paginatedData);
  };

  const handleCloseWithdrawlCurrencyModal = () =>
    setWithdrawlCurrencyModal(false);
  const handleDepositeCurrencyModal = () => setDepositeCurrencyModal(false);
  const handleCloseSendModal = () => (
    setSendModal(false),
    reset(),
    setsendTab(`${brokerBasicInfo?.companyName} WALLET`),
    setTokenType(""),
    setNetworkFee(""),
    setGstCharge(""),
    setTdsCharge(""),
    setErrormsg(""),
    setMemoreRequired(0),
    setMaxDisable(false),
    setBalance(0)
  );
  const handleCloseDepositeModal = () => setDepositeModal(false);
  const handleCloseInfoModal = () => setInfoModal(false);

  const handleChangeSendTab = (event, newValue) => {
    setsendTab(newValue);
    setMaxDisable(false);
  };

  const handleUnderstand = () => {
    const newSetting = JSON.parse(
      localStorage.getItem("user_app_settings_list_tire")
    );
    const tireType = localStorage.getItem("UserTiretype");
    // console.log("newSetting", currencyId, tireType, newSetting);
    newSetting?.forEach((item) => {
      localStorage.setItem("txncharge", item.gatewayTxnCharge);
      setTxnCharge(item.gatewayTxnCharge);
      if (item.currencyId == currencyId && item.tierType == tireType) {
        setMaxValueCoin(Number(item.dailySendLimit));
        setMinValueCoin(Number(item.minLimit));
        setSendDisclaimerCoin(item.sendOtherMCharges);
      }
    });
    const userAppSettingsObj = JSON.parse(
      localStorage.getItem("user_app_settings_list")
    );
    const lockStatus = userAppSettingsObj?.lock_outgoing_transactions;
    setLockOutgoingTransactionStatus(lockStatus);
    getOtherWalletValuePol();
    handleCloseWithdrawlCurrencyModal();
    if (cryptoCurrency === "USDT" || cryptoCurrency === "HCX") {
      setCurrencyMiddleSendModal(true);
    } else {
      setSendModal(true);
    }
  };

  useEffect(() => {
    getCountryFlag();
    getEnableDisableStatus();
  }, []);

  const getCountryFlag = async () => {
    const response = await axios.get(
      `https://accounts.paybito.com/api/home/getExchangeCountries/${localStorage.getItem(
        "BROKERID"
      )}}`
    );

    const sortCountry = response?.data?.countries
      ?.sort((a, b) =>
        a.country.toLowerCase().localeCompare(b.country.toLowerCase())
      )
      ?.map((country) => ({
        value: country.dialCode,
        country: country.country,
        label: `(+${country.dialCode}) ${country.country}`,
        flag: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`,
      }));
    setCountryFlag(sortCountry);
    setFilterCountry(sortCountry);
    
    const userCountryMatch = sortCountry.find(
      (c) => c.country?.toLowerCase() === userCountry?.toLowerCase()
    );
    setSelectedCountry(userCountryMatch || sortCountry[0]);
  };

  useEffect(() => {
    handleFilterCountry();
  }, [searchTerm]);

  const handleFilterCountry = () => {
    const term = searchTerm.toLowerCase().trim();
    if (term) {
      const filteredData = countryFlag.filter(
        (country) =>
          country.country.toLowerCase().includes(term) ||
          String(country.value).toLowerCase().includes(term)
      );
      setFilterCountry(filteredData);
    } else {
      setFilterCountry(countryFlag);
    }
  };

  console.log("filteredCountries", filteredCountries);

  const handleUnderstandDeposite = () => {
    if (cryptoCurrency === "USDT" || cryptoCurrency === "HCX") {
      setCurrencyMiddleModal(true);
    } else {
      getCurrencyForRecieveNative(cryptoCurrency, currencyId, "");
      setDepositeCurrencyModal(false);
      setDepositeModal(true);
    }
  };

  const handleCopy = (copydata) => {
    navigator.clipboard
      .writeText(copydata)
      .then(() => {
        showToast("success", "Copied");
      })
      .catch((err) => {
        showToast("error", "Failed to copy: ");
      });
  };
  const handleCopyTag = () => {
    navigator.clipboard
      .writeText(coinTag)
      .then(() => {
        showToast("success", "Copied");
      })
      .catch((err) => {
        showToast("error", "Failed to copy: ");
      });
  };
  useEffect(() => {
    getUserTransactionBalanceRest();
    return () => {
      if (moonPayBalanceIntervalRef.current) {
        clearInterval(moonPayBalanceIntervalRef.current);
      }
    };
  }, []);

  const getUserTransactionBalanceRest = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      const balance = result.userBalanceList;

      // handleFiatRate(balance);

      const arr = balance.map((item) => {
        if (item.currencyType === 1 && item.currencyCode !== "USD") {
          const matchingFiat = fiatRateArray.find(
            (rate) => rate.currencyCode === item.currencyCode
          );
          if (matchingFiat) {
            item.lastPrice = matchingFiat.rate;
          }
        }
        return item;
      });

      setMyBalanceList(arr);
      setMyBalanceListOriginal(arr);

      // const basecur = arr.filter((x) => x.currencyCode === 'USD');
      // if (basecur.length > 0) {
      //   const usdItem = basecur[0];
      //   setUsdbalance1(
      //     parseFloat(usdItem.closingBalance).toFixed(
      //       getSpecificCurrencyPrecision('USD')
      //     )
      //   );
      //   setFiatCurrencyId(usdItem.currencyId);
      // }
    } catch (error) {
      console.error("Error fetching user balance:", error);
    }

    // getUserBalance();
  };

  const handleInfoModal = (index) => {
    setInfoIndex(index);
    setInfoModal(true);
  };

  const handleCoinSearch = (e) => {
    setSearchCoin(e.target.value);
  };
  useEffect(() => {
    handleCoinFilter();
  }, [searchCoin]);
  const handleCoinFilter = useCallback(() => {
    if (searchCoin !== "") {
      const filterData = myBalanceListOriginal?.filter((d) =>
        d?.currencyCode?.toLowerCase().includes(searchCoin?.toLowerCase())
      );
      setMyBalanceList(filterData);
    } else {
      setMyBalanceList(myBalanceListOriginal);
    }
  }, [searchCoin]);

  const isActive = (b) => [3, 10, 11].includes(b.currencyActivationStatus);
  const isFiat = (b) =>
    ["USD", "AED", "INR", "EUR", "SGD", "GBP", "CAD"].includes(b.currencyCode);

  const handleSend = async (
    elem,
    bal,
    cid,
    name,
    memorerequired,
    transType
  ) => {
    const isAccreditationEnabled = await checkCurrencyAccreditedStatus(
      localStorage.getItem("userId"),
      elem.toUpperCase(),
      transType === "send" ? "WITHDRAW" : "DEPOSIT",
      0
    );

    if (!isAccreditationEnabled) {
      setShowAccreditedPopup(true);
      return;
    }
    if (transType === "send") {
      setWithdrawlCurrencyModal(true);
    } else {
      setDepositeCurrencyModal(true);
    }
    setMemoreRequired(memorerequired);
    checkUserBlockStatus();
    setTransactionType(transType);
    getmodalcurrency(elem, bal, cid, name);
  };

  const handleMoonPayRedirection = async (currencyCode) => {
    const uuid = localStorage.getItem("uuid");
    const crypto = currencyCode;
    const email = localStorage.getItem("email");
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("access_token");

    // ✅ Get base URL from environment or use default
    const BASE_URL = `${window.location.origin}/crypto-payment`;

    // ✅ URL encode the parameters
    const params = new URLSearchParams({
      userId: userId,
      email: email,
      uuid: uuid,
      crypto: crypto,
      token: token,
    });

    // ✅ Build the redirect URL
    const redirectUrl = `${BASE_URL}/setup?${params.toString()}`;

    console.log("🔗 Opening in new tab:", redirectUrl);

    // ✅ Open in new tab
    window.open(redirectUrl, "_blank");

    // ✅ Start polling for updated balance every 10 seconds
    if (moonPayBalanceIntervalRef.current) {
      clearInterval(moonPayBalanceIntervalRef.current);
    }
    moonPayBalanceIntervalRef.current = setInterval(() => {
      getUserTransactionBalanceRest();
    }, 10000);

    // ✅ When user returns to tab, fetch balance immediately and stop polling
    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" &&
        moonPayBalanceIntervalRef.current
      ) {
        getUserTransactionBalanceRest();
        clearInterval(moonPayBalanceIntervalRef.current);
        moonPayBalanceIntervalRef.current = null;
        document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange
        );
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
  };

  const getmodalcurrency = (elem, bal, cid, name) => {
    setSendTowalletButtonStatus(null);
    setSendErrorMessage("");
    setValidmsg(null);
    setErrormsg("");
    setCryptoCurrency(elem);
    setCurrencyFullName(name);
    setCurrencyCode(elem);
    setBalance(bal);
    setMiningFees(0);
    setCurrencyId(cid);
    localStorage.setItem("currencyId", cid);
    getTokenTypeByCurrencyId(cid);
  };
  const getTokenTypeByCurrencyId = async (currencyId) => {
    const payload = { currencyId };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/currencyTokenTypeById`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const res = response.data;

      if (res.error?.error_data !== 0) {
        showToast("error", res.error.error_msg);
      } else {
        const list = res.response;
        let tokenType = "";

        for (let i = 0; i < list.length; i++) {
          if (list[i].currencyId === currencyId) {
            tokenType = list[i].tokenType;
            break;
          }
        }
        setTokenTypeInitial(tokenType);

        localStorage.setItem("tokenType", tokenType);
      }
    } catch (reason) {
      if (reason.response?.data?.error === "invalid_token") {
        //logout
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        showToast("error", "Could Not Connect To Server");
      }
    }
  };

  const checkUserBlockStatus = async () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}user/userAccountStatus`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      console.log("response kk", response);

      if (response.data.error?.error_data !== 0) {
        showToast("error", response.data.error.error_msg);
        return false;
      }

      if (response.data.status !== 1) {
        //logout
        showToast("error", "Your user has been blocked by Admin");
        return false;
      }

      return true;
    } catch (error) {
      console.log("Error in checkUserBlockStatus:", error);
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === "401")
      ) {
        //logout
      }
      return false;
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  const onSubmit = (data) => {
    console.log("Form Submitted Data:", data);
  };
  useEffect(() => {
    if (tokentype) {
      getOtherWalletValuePol();
    }
  }, [tokentype]);

  const getOtherWalletValuePol = () => {
    setErrormsg("");
    setNetworkfee("");
    setGstCharge(0);
    setTdsCharge(0);
    setGstRate(0);
    setTdsRate(0);

    console.log("tokentype---11", tokentype, "1", tokentypeinitial);

    const otherwalletbalanceobj = {
      currencyId: currencyId,
      userCountry: userCountry,
      // tokenType: tokentype,
    };
    if (currencyId == 16) {
      if (tokentype === "BSC" || tokentype === "bsc") {
        otherwalletbalanceobj["tokenType"] = "bep";
      } else {
        otherwalletbalanceobj["tokenType"] = tokentype.toLowerCase();
      }
    } else if (currencyId == 148) {
      otherwalletbalanceobj["tokenType"] = (
        tokentype ? tokentype : tokentypeinitial
      ).toLowerCase();
    } else {
      otherwalletbalanceobj["tokenType"] = tokentypeinitial?.toLowerCase();
    }

    const jsonString = JSON.stringify(otherwalletbalanceobj);

    axios
      .post(
        `${WEBSERVICE}transaction/getFeesByCurrencyId`, // Replace with actual web service URL
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (
          result.fees.gstCharge !== undefined &&
          result.fees.gstCharge !== null
        ) {
          setGstRate(result.fees.gstCharge);
        }
        if (
          result.fees.tdsCharge !== undefined &&
          result.fees.tdsCharge !== null
        ) {
          setTdsRate(result.fees.tdsCharge);
        }
        setOtherWalletMinValue(result.fees.minFee);
        setOtherWalletMiningFees(result.fees.feeRate);
        setCurPrecision(result.fees.currencyPrecision);
      })
      .catch((error) => {
        console.error(error);
        // setErrormsg("An error occurred while fetching wallet fees.");
      });
  };

  const checkNodeaddress = (toAdd) => {
    if (toAdd) {
      const checknodeObj = {
        toAdd,
        currencyId,
      };

      if (cryptoCurrency === "HCX") {
        checknodeObj.tokenType = tokentype.toLowerCase();
      }
      if (cryptoCurrency === "USDT") {
        checknodeObj.tokenType = tokentype.toLowerCase();
      }
      if (tokentype == "BSC" || tokentype == "bsc") {
        checknodeObj.tokenType = "bep";
      }

      console.log("tokentype", tokentype);

      const jsonString = JSON.stringify(checknodeObj);

      axios
        .post(`${WEBSERVICE}transaction/checkNodeAddress`, jsonString, {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        })
        .then((response) => {
          const result = response.data;
          setValidmsg(result.error.error_data);
          setIsTravelData(result?.isTravelData);

          if (result.error.error_data !== 0) {
            setErrormsg(result.error.error_msg);
          } else {
            setErrormsg(result.error.error_msg);
            // Optionally show success alert here
            // alert(result.error.error_msg);
          }
        })
        .catch((error) => {
          console.error("Error during checkNodeaddress:", error);
        });
    } else {
      setErrormsg("");
    }
  };
  const getPolOtherWalletValue = async () => {
    setErrorMsg("");
    setNetworkFee("");
    setGstCharge(0);
    setTdsCharge(0);
    setGstRate(0);
    setTdsRate(0);

    const otherWalletErcBalanceObj = {
      currencyId,
      userCountry: userCountry,
      tokenType: tokentype,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getFeesByCurrencyId`,
        otherWalletErcBalanceObj,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;

      if (
        result.fees.gstCharge !== undefined &&
        result.fees.gstCharge !== null
      ) {
        setGstRate(result.fees.gstCharge);
      }

      if (
        result.fees.tdsCharge !== undefined &&
        result.fees.tdsCharge !== null
      ) {
        setTdsRate(result.fees.tdsCharge);
      }

      setOtherWalletMinValue(parseFloat(result.fees.minFee));
      setOtherWalletMiningFees(result.fees.feeRate);
      setCurPrecision(result.fees.currencyPrecision);
    } catch (error) {
      setErrorMsg("An error occurred while fetching wallet data.");
    }
  };
  const checkPhoneNumber = (value) => {
    console.log("clicckckssda");
  };

  useEffect(() => {
    if (withdrawWhiteEnableDisableStatus) {
      setSelectedAddressOption("Choose Address");
    } else {
      setSelectedAddressOption("Enter Address");
    }
  }, [withdrawWhiteEnableDisableStatus]);

  console.log("tokentype", tokentype);

  const rate = async (amount) => {
    const feeObj = {
      currencyId,
      sendAmount: amount,
      marginType: 1,
      userCountry: userCountry,
    };
    if (currencyId === 16) {
      if (tokentype === "BSC" || tokentype === "bsc") {
        feeObj["tokenType"] = "bep";
      } else {
        feeObj["tokenType"] = localStorage.getItem("tokenType");
      }
    } else {
      feeObj["tokenType"] = localStorage.getItem("tokenType");
    }
    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getFees`,
        JSON.stringify(feeObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      // setNetworkFee((minFee + feeRate).toFixed(curPrecision));
      setNetworkFee(response?.data?.feesListResult[0]?.totalFees);
    } catch (error) {
      console.error("Fee API error:", error);
    }
  };
  const getSpecificCurrencyPrecision = (cr) => {
    // Logic to return specific precision for the currency (cr)
    // Replace with the actual implementation
    return 2; // Example precision, adjust as needed
  };

  const decimalCount = (amount) => {
    // Logic to count the decimals in the amount string
    return amount.split(".")[1] ? amount.split(".")[1].length : 0;
  };

  const checkAmoutPrecision = (cr, amount, type, walletType) => {
    const precision = getSpecificCurrencyPrecision(cr);
    console.log("precision", precision);

    const decimalCountValue = decimalCount(amount);

    if (
      walletType === "walletAmount" &&
      Number(amount) > Number(maxWalletAmount)
    ) {
      showToast("error", "Insufficient balance");
    }
    if (walletType === "exWallet" && Number(amount) > Number(maxExAmount)) {
      showToast("error", "Insufficient balance");
    }

    let updatedAmount = amount;
    if (precision === 0) {
      updatedAmount =
        amount.indexOf(".") >= 0
          ? amount.substr(0, amount.indexOf(".")) +
            amount.substr(amount.indexOf("."), precision + 1)
          : amount;

      updatedAmount = updatedAmount.replace(".", "");
      if (type === "WALLET") {
        setPaybitoAmount(updatedAmount);
      } else {
        setOtherAmount(updatedAmount);
      }
    } else {
      updatedAmount =
        amount.indexOf(".") >= 0
          ? amount.substr(0, amount.indexOf(".")) +
            amount.substr(amount.indexOf("."), precision + 1)
          : amount;

      if (type === "WALLET") {
        setPaybitoAmount(updatedAmount);
      } else {
        setOtherAmount(updatedAmount);
      }
    }
  };
  const getOnlyMaxAmount = () => {
    // Assuming this method fetches the max amount allowed
    return 1000; // Example value
  };

  const calculateFeeOnKeyUpForPaybitoWalletAmount = (balancee) => {
    if (parseFloat(balancee) > 0) {
      const tds = balancee * (tdsRate / 100);
      const gst = balancee * (gstRate / 100);

      setTdsCharge(tds.toFixed(curPrecision));
      setGstCharge(gst.toFixed(curPrecision));

      // Disable submit button if amount exceeds max amount
      if (getOnlyMaxAmount() < parseFloat(balancee)) {
        setIsSubmitDisabled(true);
      } else {
        setIsSubmitDisabled(false);
      }
    }
  };
  const MaxSendAmountPaybitoWallet = () => {
    setMaxDisable(true);
    const minFee = otherWalletMinValue;
    const feeRate = ((balance - minFee) * otherWalletMiningFees) / 100;
    const gst = (minFee + feeRate) * (gstRate / 100);
    const tds = balance * (tdsRate / 100);
    // const tds = (balance - (minFee + feeRate + gst)) * (tdsRate / 100);
    const calculatedMax = balance ? (balance - tds).toFixed(curPrecision) : 0;

    const calculatedGst = gst.toFixed(curPrecision);
    const calculatedTds = tds.toFixed(curPrecision);
    const calculatedNetworkFee = (minFee + feeRate).toFixed(curPrecision);
    // If balance is less than the minimum wallet value

    console.log("calculatedMax", calculatedMax);
    if (balance <= otherWalletMinValue) {
      setOtherAmount(0);
      setNetworkFee("");
      setGstCharge(0);
      setTdsCharge(0);
      setMaxSendAmount(0);
      setPaybitoAmount(0);

      setValue("bitprimeAmount", 0);
    } else {
      setValue("bitprimeAmount", calculatedMax);

      setMaxSendAmount(calculatedMax);
      setPaybitoAmount(calculatedMax);
      setOtherAmount(calculatedMax);
      setGstCharge(calculatedGst);
      setTdsCharge(calculatedTds);
      setNetworkFee(calculatedNetworkFee);
    }
  };

  console.log(
    "maxSendAmount",
    maxWalletAmount,
    watch("bitprimeAmount"),
    watch("bitprimeAmount") > Number(maxWalletAmount)
  );
  const MaxSendAmountExWallet = () => {
    setMaxDisable(true);
    const minFee = otherWalletMinValue;
    const feeRate = ((balance - minFee) * otherWalletMiningFees) / 100;
    const gst = (minFee + feeRate) * (gstRate / 100);
    const tds = (balance - (minFee + feeRate + gst)) * (tdsRate / 100);
    const calculatedMax = balance
      ? (balance - (minFee + feeRate + gst + tds)).toFixed(curPrecision)
      : 0;

    const calculatedGst = gst.toFixed(curPrecision);
    const calculatedTds = tds.toFixed(curPrecision);
    const calculatedNetworkFee = (minFee + feeRate).toFixed(curPrecision);
    // If balance is less than the minimum wallet value

    console.log("calculatedMax", calculatedMax);
    if (balance <= otherWalletMinValue) {
      setOtherAmount(0);
      setNetworkFee("");
      setGstCharge(0);
      setTdsCharge(0);
      setMaxSendAmount(0);
      setPaybitoAmount(0);

      setValue("externalAmount", 0);
    } else {
      setValue("externalAmount", calculatedMax);

      setMaxSendAmount(calculatedMax);
      setPaybitoAmount(calculatedMax);
      setOtherAmount(calculatedMax);
      setGstCharge(calculatedGst);
      setTdsCharge(calculatedTds);
      setNetworkFee(calculatedNetworkFee);
    }
    console.log(
      "calculatedNetworkFee",
      balance,
      otherWalletMinValue,
      calculatedNetworkFee,
      calculatedMax
    );
  };

  const checkforLockStatusWhileSendingToPaybito = () => {
    const twoFactorAuth = localStorage.getItem("twoFactorAuth");
    setTwoFactorOtpOnly("");

    if (twoFactorAuth === "1") {
      setAuthModalOpen(true);
      getCodeFromEmail();
    } else {
      showToast(
        "warning",
        "Please turn on Two Factor Authentication from Settings first"
      );
    }
  };

  const checkUserHasGeneratedAddress = async () => {
    const payload = {
      uuid: localStorage.getItem("uuid"),
      currencyId: localStorage.getItem("currencyId"),
      currency: cryptoCurrency,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/checkSenderNodeAddress`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;
      if (result.code !== 0) {
        showToast("warning", result?.message);
      } else {
        checkforLockStatusWhileSendingToPaybito();
      }
    } catch (error) {
      showToast("error", error.message || "Something went wrong");
    }
  };

  const transactionSendWithinPaybito = async () => {
    const a = await checkUserBlockStatus(); // Assuming this is a function that returns a boolean

    const isAccreditationEnabled = await checkCurrencyAccreditedStatus(
      localStorage.getItem("userId"),
      cryptoCurrency,
      "SELL",
      sendTab === `${brokerBasicInfo?.companyName} WALLET`
        ? watch("bitprimeAmount")
        : watch("externalAmount")
    );

    if (!isAccreditationEnabled) {
      setShowAccreditedPopup(true);
      return;
    }

    if (a === true) {
      const sendToPaybitoObj = {
        uuid: localStorage.getItem("uuid"),
        currencyId: localStorage.getItem("currencyId"),
        currency: cryptoCurrency,
      };

      if (sendTab === `${brokerBasicInfo?.companyName} WALLET`) {
        sendToPaybitoObj.toAdd = watch("mobile");
        sendToPaybitoObj.sendAmount = watch("bitprimeAmount");
      } else {
        sendToPaybitoObj.sendAmount = watch("externalAmount");
        if (selectedAddressOption === "Enter Address") {
          sendToPaybitoObj.toAdd = watch("externalInputAddress");
        } else {
          sendToPaybitoObj.toAdd = watch("externalSelectAddress");
        }
      }

      if (lockOutgoingTransactionStatus === 1) {
        sendToPaybitoObj.securityCode = twoFactorOtp;
      }

      const jsonString = JSON.stringify(sendToPaybitoObj);
      console.log("new address payload", jsonString);

      try {
        const response = await axios.post(
          `${WEBSERVICE}transaction/sendToWallet`,
          jsonString,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        );

        const result = response.data;
        if (result.error.error_data !== 0) {
          if (result.error.error_data === 2) {
            showErrorDialog(result);
          } else {
            showToast("error", result.error.error_msg);
          }
        } else {
          showToast("success", "Sent successfully");
          reset();
          handleCloseAuthModal();
          setPaybitoPhone("");
          setPaybitoAmount("");
          setTwoFactorOtp("");
          setEmailOtp("");
          // Call your methods for refreshing user data
          getUserTransactionBalanceRest();
          walletHistoryList("1", transactionType);

          handleCloseSendModal();
          handleCloseWithdrawlCurrencyModal();
        }
      } catch (error) {
        console.error("Error sending transaction:", error);
        if (error.response?.status === 401) {
          //logout
        } else {
          showToast("error", error?.response?.data?.error?.error_msg);
        }
      }
    }
  };

  const transactionSendForOthers = async () => {
    try {
      const isBlocked = await checkUserBlockStatus();
      if (!isBlocked) return;

      const isAccreditationEnabled = await checkCurrencyAccreditedStatus(
        localStorage.getItem("userId"),
        cryptoCurrency,
        "SELL",
        watch("externalAmount")
      );

      if (!isAccreditationEnabled) {
        setShowAccreditedPopup(true);
        return;
      }

      let sendToPaybitoObj = {
        uuid: localStorage.getItem("uuid"),
        currencyId: localStorage.getItem("currencyId"),
        currency: cryptoCurrency,
        memo: watch("externalMemo"),
        totalFees: networkFee,
        otp: emailOtp,
        securityCode: twoFactorOtp,
        sendAmount: watch("externalAmount"),
      };
      if (selectedAddressOption === "Enter Address") {
        sendToPaybitoObj.toAdd = watch("externalInputAddress");
      } else {
        sendToPaybitoObj.toAdd = watch("externalSelectAddress");
      }

      if (cryptoCurrency === "HCX") {
        sendToPaybitoObj["tokenType"] = tokentype.toLowerCase();
      }
      if (cryptoCurrency === "USDT") {
        sendToPaybitoObj["tokenType"] = tokentype.toLowerCase();
        // sendToPaybitoObj["currency"] = "USDT TRC";
      }

      const url =
        cryptoCurrency !== "triggers"
          ? "/transaction/sendToOther"
          : "/userTransaction/SendTriggers";

      const response = await axios.post(
        `${WEBSERVICE}${url}`,
        JSON.stringify(sendToPaybitoObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        if (result.error.error_data === 2) {
          showErrorDialog(result);
        } else {
          showToast("error", result.error.error_msg);
        }
      } else {
        if (
          isTravelData === 2 ||
          isTravelData === "2" ||
          result.usdValue < 1000
        ) {
        } else {
          setShowQuestionModal(true);
        }
        showToast("success", "Balance transferred successfully");
        handleCloseAuthModal();
        handleCloseSendModal();
        handleCloseWithdrawlCurrencyModal();

        if (cryptoCurrency !== "triggers") {
          setCryptoRcvTrnId(result.transactionId);
          getUserTransactionBalanceRest();
          walletHistoryList("1", transactionType);
          // openQuestionModal();
        }
      }
    } catch (error) {
      showToast("error", error.message || error);
    }
  };

  const getUserTransaction = async () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };
    const jsonString = JSON.stringify(userTransObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", "Cannot fetch user balance");
        console.log("Fetching User balance failed");
      } else {
        setUserBalanceList(result.userBalanceList);

        result.userBalanceList.forEach((balance) => {
          if (balance.currencyCode === "USD") {
            setUsdbalance(balance.closingBalance);
            localStorage.setItem("usdbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "SGD") {
            setSgdbalance(balance.closingBalance);
            localStorage.setItem("sgdbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "EUR") {
            setEurbalance(balance.closingBalance);
            localStorage.setItem("eurbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "AED") {
            setAedbalance(balance.closingBalance);
            localStorage.setItem("aedbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "INR") {
            setInrbalance(balance.closingBalance);
            localStorage.setItem("inrbalance", balance.closingBalance);
          }
          if (balance.currencyCode === "GBP") {
            setGbpbalance(balance.closingBalance);
            localStorage.setItem("gbpbalance", balance.closingBalance);
          }
        });

        setSelectedCryptoCurrency(localStorage.getItem("selected_currency"));

        const fiatCurrencies = result.userBalanceList.filter(
          (balance) => balance.currencyType === "1"
        );
        setFiatCurrencyList(fiatCurrencies);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        logout();
      } else {
        // showToast("error", error?.response?.data?.error?.error_msg);
      }
    }
  };

  const getEnableDisableStatus = async () => {
    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getEnableDisableStatus`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data?.error?.error_data === 0) {
        setWithdrawWhiteEnableDisableStatus(
          response.data.addressWhitelistStatus
        );
      } else {
        setWithdrawWhiteEnableDisableStatus(0);
        setError(response.data.error);
        showToast("error", response.data?.error?.error_msg); // You can customize this alert
      }
    } catch (err) {
      setError("An error occurred while fetching data");
      console.error(err);
    }
  };

  const readable_timestamp = (t) => {
    var t = t.split(/[- :]/);
    var d = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]));
    d.setMinutes(d.getMinutes() - 330);
    t = d.toTimeString();
    t = t.split(" ");
    return d.toDateString() + " " + t[0];
  };

  const showTravelData = async (type) => {
    const historyObj = {
      uuid: localStorage.getItem("uuid"),
      pageNo: 1,
      noOfItemsPerPage: 50,
      timeSpan: "all",
      transactionType: type,
    };

    const jsonString = JSON.stringify(historyObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserAllTransaction`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        // showToast("error", result.error.error_msg);
      } else {
        if (type === "send") {
          const transactions1 = result.userTransactionsResult || [];
          setSendTransactions(transactions1);
          setSendDone(true);
        } else {
          const transactions2 = result.userTransactionsResult || [];
          setRcvTransactions(transactions2);
          setRcvDone(true);
        }
      }
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        logout();
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        //logout
      }
      // showToast("error", error?.response?.data?.error?.error_msg);
    }
  };

  const walletHistoryList = async (pageNo, type) => {
    setWhistoryDetails1([]);

    const historyObj = {
      uuid: localStorage.getItem("uuid"),
      pageNo: pageNo,
      noOfItemsPerPage: 50,
      timeSpan: "all",
      transactionType: type,
    };

    const jsonString = JSON.stringify(historyObj);

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserAllTransaction`,
        jsonString,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
      } else {
        if (result.error.error_msg === "no result") {
          setWhistoryDetails([]);
          setWhistoryDetails1([]);
        } else {
          const transactions = result.userTransactionsResult || [];

          // Assuming whistoryDetailsSend comes from somewhere else (state or props)
          const details1 = transactions.map((txn) => {
            const timestamp = readable_timestamp(
              txn.transactionTimestamp.split(".")[0]
            );
            const action = txn.action;
            const isBalanceLocked = txn.isBalanceLocked;
            const isTravelData = txn.isTravelData;
            const sendReceiveType = txn.sendReceiveType;

            let amount = "";
            let amountdbtcrdt = "";
            let hrefForTxn = "";
            let hrefForTxn1 = "";

            if (action === "Send" || transactionType === "send") {
              if (txn.debitAmount !== "0" && txn.currency) {
                amount = txn.currency;
                amountdbtcrdt = txn.debitAmount;
                if (txn.currencyTxnid && txn.currencyTxnid.length > 0) {
                  hrefForTxn = `<br><a target="_blank" href="${
                    txn.currencyUrl + txn.currencyTxnid
                  }">(Check Transaction Block)</a>`;
                  hrefForTxn1 = txn.currencyUrl + txn.currencyTxnid;
                }
              }
            }

            if (action === "Received" || transactionType === "received") {
              if (txn.creditAmount !== "0" && txn.currency) {
                amount = txn.currency;
                amountdbtcrdt = txn.creditAmount;
                if (txn.currencyTxnid && txn.currencyTxnid.length > 0) {
                  hrefForTxn = txn.currencyUrl + txn.currencyTxnid;
                  hrefForTxn1 = txn.currencyUrl + txn.currencyTxnid;
                }
              }
            }

            let status = "";
            let statusClass = "";
            if (txn.status === 1) {
              status = "Confirmed";
              statusClass = "text-green";
            } else if (txn.status === 0) {
              status = "Pending";
              statusClass = "text-orange";
            } else if (txn.status === "cancel" || txn.status === "Cancel") {
              status = "Cancelled";
              statusClass = "text-red";
            }

            const description = txn.description || "Received Amount";
            const shortDescription =
              description.length < 100
                ? `${description} ${hrefForTxn}`
                : `${description.substr(0, 100)}... ${hrefForTxn}`;

            return {
              description: txn.description,
              transactionId: txn.transactionId,
              timestamp,
              amount,
              amountdbtcrdt,
              action,
              status,
              statusClass,
              descriptionTd: description,
              hrefForTxn: hrefForTxn1,
              isBalanceLockedData: isBalanceLocked,
              isTravelDataStatus: isTravelData,
              sendReceiveType,
            };
          });

          setWhistoryDetails(transactions);
          setWhistoryDetails1(details1);
          const initialData = details1?.slice(0, itemsPerPage);
          setCurrentPageData(initialData);
          setTotalCount(result.totalCount);

          const pageCount = Math.ceil(result.totalCount / 20);
          setPgn(Array.from({ length: pageCount }, (_, i) => i + 1));

          getUserTransaction();
        }
      }
    } catch (error) {
      if (error.response?.data?.error === "invalid_token") {
        logout();
        showToast("warning", "SESSION TIMED OUT. LOGIN AGAIN");
      } else {
        //logout
      }
      // showToast("error", error?.response?.data?.error?.error_msg);
    }
  };
  const precisionCheck = (amount) => {
    return parseFloat(amount).toFixed(6);
  };

  const filterType = (type) => {
    setTransactionType(type);
    walletHistoryList(1, type);
  };

  const resetQuestionData = () => {
    setRecipientNameRcv("");
    setAccountNumberRcv("");
    setCryptoEmailAddressRcv("");
    setCryptoFirmRcv("");
    setRecipientName("");
    setAccountNumber("");
    setCryptoEmailAddress("");
  };

  const getUserTravelDataRcv = async (id) => {
    resetQuestionData();

    setCryptoRcvTrnId(id);

    const inputObj = {
      transactionId: id,
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserTravelData`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const travelData = response.data.userTravelData;

      setRecipientName(travelData.name || "");
      setAccountNumber(travelData.accountId || "");
      setCryptoEmailAddress(travelData.firmEmail || "");

      setRecipientNameRcv(travelData.name || "");
      setAccountNumberRcv(travelData.accountId || "");
      setCryptoEmailAddressRcv(travelData.uniqueId || "");
    } catch (error) {
      // In case of error, reset all
      setRecipientName("");
      setAccountNumber("");
      setCryptoEmailAddress("");

      setRecipientNameRcv("");
      setAccountNumberRcv("");
      setCryptoEmailAddressRcv("");
    }

    if (transactionType === "send") {
      setShowQuestionModal(true);
    } else {
      setShowQuestionModalRecieve(true);
    }
  };

  const getAllAddressList = () => {
    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      crypto: cryptoCurrency,
      isWhitelist: withdrawWhiteEnableDisableStatus === 1 ? 2 : "",
      searchStr: "",
      offset: 1,
      limit: 100,
    };

    axios
      .post(
        `${WEBSERVICE}transaction/getWhitelistedAddress`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((response) => {
        const res = response.data;
        if (res.error.error_data === 0) {
          if (
            !res.whitelistedAddressList ||
            res.whitelistedAddressList.length === 0
          ) {
            setWhitelistAddressDetailsList([]);
          } else {
            setWhitelistAddressDetailsList(res.whitelistedAddressList);
          }
        } else {
          showToast("error", res.error.error_msg);
        }
      })
      .catch((error) => {
        showToast(
          "error",
          "An error occurred while fetching the address list."
        );
        console.error(error);
      });
  };

  const getCurrencyForRecieveNative = (currency, CID, tokenType) => {
    console.log("tokenType", tokenType);
    setTokenType(tokenType);
    setCryptoCurrency(currency);
    setCurrencyId(CID);
    generateAddressForNative(currency, CID, tokenType);

    // Trigger modal
  };
  const getCurrencyForSendNative = (currency, CID, tokenType) => {
    console.log("tokenType", tokenType);
    setTokenType(tokenType);
    setCryptoCurrency(currency);
    setCurrencyId(CID);
    setSendModal(true);

    // Trigger modal
  };

  const generateAddressForNative = async (currency, currencyId, tokenType) => {
    setRcv(null);
    setCoinTag(null);

    const rcvObj = {
      uuid: localStorage.getItem("uuid"),
      currencyId: currencyId,
      marginType: "1",
    };

    if (currency === "HCX" || currency === "USDT") {
      if (tokenType === "BSC" || tokenType === "bsc") {
        rcvObj.tokenType = "bep";
      } else {
        rcvObj.tokenType = tokenType.toLowerCase();
      }
    }
    // else if( currency === "AAVE" || currency === "LINK" || currency === "BAT") {
    //   rcvObj.tokenType = "erc";
    // }
    // else if(  currency === "PUSD" || currency === "USDB") {
    //   rcvObj.tokenType = "HcNet";
    // }
    else {
      if (currency === "AFAS" || currency === "NVCT") {
        rcvObj.tokenType = "base";
      } else {
        rcvObj.tokenType = tokentypeinitial;
      }
    }

    const url =
      currency !== "triggers"
        ? `${WEBSERVICE}transaction/getCryptoAddress`
        : `${WEBSERVICE}userTransaction/GetCounterPartyNewAddress`;

    try {
      const response = await axios.post(url, JSON.stringify(rcvObj), {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      });

      const result = response.data;

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
        setRcv(null);
      } else {
        const publicKey = result.customerLedgerResult.publicKey;
        const memo = result.customerLedgerResult.memo;

        setRcv(publicKey);
        setCoinTag(memo);
        if (currency === "USDT" || currency === "HCX") {
          setDepositeModal(true);
        }
      }
    } catch (error) {
      setRcv(null);
      showToast("error", "Something went wrong while generating address.");
    }
  };

  const getCodeFromEmail = () => {
    const getotpObj = {
      email: localStorage.getItem("email"),
    };

    setIsGetCodeButtonDisabled(true);

    axios
      .post(
        `${WEBSERVICE}user/ResendOTP/sendtoother`,
        JSON.stringify(getotpObj),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const result = response.data;
        if (result.error.error_data !== 0) {
          setIsGetCodeButtonDisabled(false);
          showToast("error", result.error.error_msg);
        } else {
          showToast("success", "OTP Sent Successfully to Registered Email Id");
          // startTimer();
          setTimer(true);
          setEmailOtpTime(300);
        }
      })
      .catch((error) => {
        showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        setIsGetCodeButtonDisabled(false);
      });
  };

  const isDisable = () => {
    const address =
      selectedAddressOption === "Enter Address"
        ? watch("externalInputAddress")
        : watch("externalSelectAddress");

    const amount = watch("externalAmount");

    const hasErrorMsg = !!errormsg; // true if errormsg is not empty

    if (
      amount &&
      address &&
      (!hasErrorMsg || errormsg === "Valid address.") && // ✅ check only if errormsg has value
      amount >= minValueCoin &&
      amount <= maxValueCoin &&
      watch("externalAmount") <= maxExAmount
    ) {
      return false; // ENABLE button
    }

    return true; // DISABLE button
  };

  return (
    <Box sx={pageWrapper}>
      {/* ── Hero Banner ── */}
      <Box
        sx={{
          ...heroBanner,
          background: `linear-gradient(135deg, ${alpha(
            btncolor || "#1976d2",
            0.95
          )} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
        }}
      >
        <Box sx={heroContent}>
          <Box sx={heroIconBadge}>
            <AccountBalanceWalletOutlinedIcon
              sx={{ color: "#fff", fontSize: 30 }}
            />
          </Box>
          <Box>
            <Typography sx={heroTitle}>Spot Wallet</Typography>
            <Typography sx={heroSubtitle}>
              Manage your crypto portfolio — send, receive and track your assets
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ── Portfolio Graph ── */}
      <Box sx={{ ...mainCard, mb: 3, position: "relative" }}>
        <Box
          sx={{
            px: { xs: 2, md: 2.5 },
            pt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            mb: 2,
          }}
        >
          <Typography sx={cardSectionTitle}>Portfolio Overview</Typography>
          <span
            style={{ cursor: "pointer" }}
            onClick={() => handleInfoModal(8)}
          >
            <InfoIcon
              sx={{ fontSize: 15, color: "var(--text-color)", opacity: 0.5 }}
            />
          </span>
        </Box>
        <WalletGraph />
      </Box>

      {/* ── Assets Table ── */}
      <Box sx={{ ...mainCard, mb: 3 }}>
        <Box sx={tableHeaderRow}>
          <Box>
            <Typography sx={cardSectionTitle}>Your Assets</Typography>
            <Typography sx={cardSectionCaption}>
              Manage your portfolio holdings
            </Typography>
          </Box>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search coin..."
            onChange={handleCoinSearch}
            sx={searchFieldStyle}
          />
        </Box>
        <TableContainer sx={modernTableContainer} className="wallet_table">
          <Table stickyHeader aria-label="sticky table" sx={tableStyle}>
            <TableHead>
              <TableRow sx={modernTableHeadRow}>
                {columns.map((column, i) => (
                  <TableCell key={i} sx={modernTableHeadCell}>
                    {column} {i === 5 && currencySymbol}
                    {i !== 3 && i !== 8 && (
                      <span
                        style={{ cursor: "pointer", marginLeft: "6px" }}
                        onClick={() => handleInfoModal(i)}
                      >
                        <InfoIcon style={{ fontSize: "13px" }} />
                      </span>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {myBalanceList?.length !== 0 &&
                myBalanceList?.map((d, i) => (
                  <TableRow key={i} sx={modernTableBodyRow}>
                    <TableCell sx={modernTableBodyCell}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <img
                          alt="BTC"
                          src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${d?.currencyCode.toUpperCase()}.png`}
                          style={{
                            width: "22px",
                            height: "22px",
                            borderRadius: "50%",
                            objectFit: "contain",
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "0.85rem",
                            fontWeight: 600,
                            color: "var(--text-color)",
                          }}
                        >
                          {d?.currencyCode.toUpperCase()}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      {d?.lastPrice}
                    </TableCell>
                    <TableCell
                      sx={{
                        ...modernTableBodyCell,
                        color: parseFloat(d?.roc) >= 0 ? "#16a34a" : "#ef4444",
                        fontWeight: 600,
                      }}
                    >
                      {d?.roc}
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      {d?.closingBalance}
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      {d?.totalBalance}
                    </TableCell>
                    <TableCell sx={modernTableBodyCell}>
                      {d?.holdingInUsd}
                    </TableCell>
                    <TableCell
                      sx={{ ...modernTableBodyCell, cursor: "pointer" }}
                      /*  onClick={() => setWithdrawlCurrencyModal(true)} */
                    >
                      {d?.sendAccess === 1 &&
                        d?.currencyCode !== "HCX" &&
                        d?.currencyCode !== "USDT" &&
                        isActive(d) && (
                          <a
                            onClick={() =>
                              handleSend(
                                d?.currencyCode,
                                d?.closingBalance,
                                d?.currencyId,
                                d?.currencyName,
                                d?.memoRequired,
                                "send"
                              )
                            }
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                          >
                            SEND{" "}
                            <CallMadeIcon
                              sx={{
                                fontSize: "14px",
                                color: btncolor,
                              }}
                            />
                          </a>
                        )}

                      {d?.sendAccess === 1 &&
                        d?.currencyCode === "HCX" &&
                        isActive(d) && (
                          <a
                            onClick={() =>
                              handleSend(
                                d?.currencyCode,
                                d?.closingBalance,
                                d?.currencyId,
                                d?.currencyName,
                                d?.memoRequired,
                                "send"
                              )
                            }
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                          >
                            SEND{" "}
                            <CallMadeIcon
                              sx={{
                                fontSize: "14px",
                                color: btncolor,
                              }}
                            />
                          </a>
                        )}

                      {d?.sendAccess === 1 &&
                        d?.currencyCode === "USDT" &&
                        isActive(d) && (
                          <a
                            onClick={() =>
                              handleSend(
                                d?.currencyCode,
                                d?.closingBalance,
                                d?.currencyId,
                                d?.currencyName,
                                d?.memoRequired,
                                "send"
                              )
                            }
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                          >
                            SEND{" "}
                            <CallMadeIcon
                              sx={{
                                fontSize: "14px",
                                color: btncolor,
                              }}
                            />
                          </a>
                        )}

                      {isFiat(d) && d?.isWithdraw === 1 && isActive(d) && (
                        <a
                          onClick={() => navigate("/Withdraw")}
                          className={
                            themeColor === "dark" ? "text-skyblue" : "text-dark"
                          }
                          href="javascript:void(0);"
                        >
                          SEND{" "}
                          <CallMadeIcon
                            sx={{
                              fontSize: "14px",
                              color: btncolor,
                            }}
                          />
                        </a>
                      )}
                    </TableCell>
                    <TableCell
                      sx={{ ...modernTableBodyCell, cursor: "pointer" }}
                      /*  onClick={() => setDepositeCurrencyModal(true)} */
                    >
                      {d?.receiveAccess === 1 &&
                        d?.currencyCode !== "HCX" &&
                        d?.currencyCode !== "USDT" &&
                        isActive(d) && (
                          <a
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                            onClick={() =>
                              handleSend(
                                d?.currencyCode,
                                d?.closingBalance,
                                d?.currencyId,
                                d?.currencyName,
                                d?.memoRequired,
                                "receive"
                              )
                            }
                          >
                            RECEIVE{" "}
                            <CallReceivedIcon
                              sx={{
                                fontSize: "14px",
                                color: btncolor,
                              }}
                            />
                          </a>
                        )}

                      {/* HCX Currency */}
                      {d?.receiveAccess === 1 &&
                        d?.currencyCode === "HCX" &&
                        isActive(d) && (
                          <a
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                            onClick={() =>
                              handleSend(
                                d?.currencyCode,
                                d?.closingBalance,
                                d?.currencyId,
                                d?.currencyName,
                                d?.memoRequired,
                                "receive"
                              )
                            }
                          >
                            RECEIVE{" "}
                            <CallReceivedIcon
                              sx={{
                                fontSize: "14px",
                                color: btncolor,
                              }}
                            />
                          </a>
                        )}

                      {/* USDT Currency */}
                      {d?.receiveAccess === 1 &&
                        d?.currencyCode === "USDT" &&
                        isActive(d) && (
                          <a
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                            onClick={() =>
                              handleSend(
                                d?.currencyCode,
                                d?.closingBalance,
                                d?.currencyId,
                                d?.currencyName,
                                d?.memoRequired,
                                "receive"
                              )
                            }
                          >
                            RECEIVE{" "}
                            <CallReceivedIcon
                              sx={{
                                fontSize: "14px",
                                color: btncolor,
                              }}
                            />
                          </a>
                        )}

                      {/* Fiat Currencies */}
                      {["USD", "AED", "INR", "EUR", "SGD", "GBP", "CAD"].includes(
                        d?.currencyCode
                      ) &&
                        d?.isDeposit === 1 &&
                        isActive(d) && (
                          <a
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                            onClick={() => navigate("/Deposit")}
                          >
                            RECEIVE{" "}
                            <CallReceivedIcon
                              sx={{
                                fontSize: "14px",
                                color: btncolor,
                              }}
                            />
                          </a>
                        )}
                    </TableCell>
                    <TableCell
                      sx={{ ...modernTableBodyCell, cursor: "pointer" }}
                    >
                      {d?.currencyType === 2 && (
                          <a
                            className={
                              themeColor === "dark"
                                ? "text-skyblue"
                                : "text-dark"
                            }
                            href="javascript:void(0);"
                            onClick={() => {
                              // Previously used MoonPay redirection — replaced with Pabtek payment popup
                              // handleMoonPayRedirection(d?.currencyCode);
                              setPabtekCurrency({
                                id: d?.currencyId,
                                code: d?.currencyCode,
                              });
                              setPabtekPopupOpen(true);
                            }}
                          >
                            Buy with Cards{" "}
                          </a>
                        )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* ── Transaction History ── */}
      <Box sx={{ ...mainCard, mb: 3 }}>
        <Box sx={{ ...tableHeaderRow, flexWrap: "wrap", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography sx={cardSectionTitle}>
              Wallet Transactions History
            </Typography>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => setWalletTnxHModal(true)}
            >
              <InfoIcon
                sx={{ fontSize: 15, color: "var(--text-color)", opacity: 0.5 }}
              />
            </span>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              size="small"
              variant={activeButton === "send" ? "contained" : "outlined"}
              onClick={() => (setActiveButton("send"), filterType("send"))}
              sx={{
                textTransform: "uppercase",
                fontSize: "0.72rem",
                fontWeight: 700,
                borderRadius: "8px",
                px: 2,
                ...(activeButton === "send"
                  ? {
                      backgroundColor: btncolor,
                      "&:hover": {
                        backgroundColor: alpha(btncolor || "#1976d2", 0.85),
                      },
                      color: "#fff",
                      border: "none",
                    }
                  : {
                      borderColor: alpha(btncolor || "#1976d2", 0.4),
                      color: btncolor,
                    }),
              }}
            >
              SENT
            </Button>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => handleInfoModal(9)}
            >
              <InfoIcon
                sx={{ fontSize: 15, color: "var(--text-color)", opacity: 0.5 }}
              />
            </span>
            <Button
              size="small"
              variant={activeButton === "receive" ? "contained" : "outlined"}
              onClick={() => (
                setActiveButton("receive"), filterType("received")
              )}
              sx={{
                textTransform: "uppercase",
                fontSize: "0.72rem",
                fontWeight: 700,
                borderRadius: "8px",
                px: 2,
                ...(activeButton === "receive"
                  ? {
                      backgroundColor: btncolor,
                      "&:hover": {
                        backgroundColor: alpha(btncolor || "#1976d2", 0.85),
                      },
                      color: "#fff",
                      border: "none",
                    }
                  : {
                      borderColor: alpha(btncolor || "#1976d2", 0.4),
                      color: btncolor,
                    }),
              }}
            >
              RECEIVED
            </Button>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => handleInfoModal(10)}
            >
              <InfoIcon
                sx={{ fontSize: 15, color: "var(--text-color)", opacity: 0.5 }}
              />
            </span>
          </Box>
        </Box>
        <DataTable columns={TransuctionHistoryColumn}>
          {currentPageData?.length !== 0 ? (
            currentPageData?.map((data, i) => (
              <TableRow key={i} sx={modernTableBodyRow}>
                <TableCell sx={modernTableBodyCell}>
                  {data?.timestamp}
                </TableCell>
                <TableCell
                  sx={{
                    ...modernTableBodyCell,
                    width: "30%",
                    lineBreak: "anywhere",
                    whiteSpace: "normal",
                  }}
                >
                  {data?.descriptionTd}
                  <br />
                  {data.hrefForTxn !== "" && (
                    <a
                      href={data.hrefForTxn}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary"
                    >
                      (Check Transaction Block)
                    </a>
                  )}
                </TableCell>
                <TableCell sx={modernTableBodyCell}>{data?.amount}</TableCell>
                <TableCell sx={modernTableBodyCell}>
                  {precisionCheck(data.amountdbtcrdt)}
                </TableCell>
                <TableCell sx={modernTableBodyCell}>{data?.action}</TableCell>
                <TableCell
                  sx={{
                    ...modernTableBodyCell,
                    fontWeight: 600,
                    color:
                      data?.status === "Confirmed"
                        ? "#16a34a"
                        : data?.status === "Pending"
                        ? "#f59e0b"
                        : "#ef4444",
                  }}
                >
                  {data?.status}
                </TableCell>
                <TableCell sx={modernTableBodyCell}>
                  {data.isTravelDataStatus === 0 &&
                    data.sendReceiveType === "o" && (
                      <span style={{ cursor: "pointer" }} title="Pending">
                        Pending{" "}
                        <span
                          className="badge badge-warning warningicon"
                          onClick={() =>
                            getUserTravelDataRcv(data.transactionId)
                          }
                        >
                          {/* <i
                                className="fa fa-exclamation-triangle"
                                style={{
                                  color: "black",
                                }}
                                aria-hidden="true"
                              ></i> */}
                          <WarningAmberIcon
                            style={{ color: "black", fontSize: "15px" }}
                          />
                        </span>
                        <span
                          onClick={() =>
                            getUserTravelDataRcv(data.transactionId)
                          }
                        >
                          <a
                            href={"#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary"
                          >
                            Need info
                          </a>
                        </span>
                      </span>
                    )}
                  {data.isTravelDataStatus === 0 &&
                    data.sendReceiveType !== "o" && (
                      <span title="Approved">Approved</span>
                    )}
                  {data.isTravelDataStatus === 1 && (
                    <span title="Awaiting admin approval">Submitted</span>
                  )}
                  {data.isTravelDataStatus === 2 && (
                    <span title="Approved">Approved</span>
                  )}
                  {data.isTravelDataStatus === 3 && (
                    <span
                      style={{ cursor: "pointer" }}
                      title="Please validate the info and resubmit"
                    >
                      Rejected{" "}
                      <span
                        className="badge badge-warning warningicon"
                        onClick={() => getUserTravelDataRcv(data.transactionId)}
                      >
                        {/* <i
                              className="fa fa-exclamation-triangle"
                              style={{
                                color: "black",
                              }}
                              aria-hidden="true"
                            ></i> */}
                        <WarningAmberIcon
                          style={{ color: "black", fontSize: "15px" }}
                        />
                      </span>
                      <span
                        onClick={() => getUserTravelDataRcv(data.transactionId)}
                      >
                        <a
                          href={"#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-primary"
                        >
                          Need info
                        </a>
                      </span>
                    </span>
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableCell colSpan={7} sx={{ textAlign: "center" }}>
              No Data
            </TableCell>
          )}
        </DataTable>

        <ThemeProvider theme={theme}>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", px: 2.5, py: 2 }}
          >
            <Pagination
              count={pageCount}
              page={pgn}
              boundaryCount={2}
              onChange={handlePageChange}
            />
          </Box>
        </ThemeProvider>
      </Box>

      <ModalContent
        open={withdrawlCurrencyModal}
        onClose={handleCloseWithdrawlCurrencyModal}
        title={`Withdrawal ${currencyCode}`}
      >
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            textAlign: "justify",
            // color: "gray",
            // backgroundColor: themeColor === "dark" ? "#31313a" : "#fff",
            px: 4,
            py: 2,
            width: "100%",
          }}
        >
          Once your crypto withdraw operation is completed, the corresponding
          asset ownership will be changed to the account owner of the target
          address. Please make sure to check the crypto withdraw address
          information carefully before the crypto withdraw operation to ensure
          that the action is voluntary, and to confirm this action does not
          involve any pyramid schemes, illegal fund-raising, fraud and other
          illegal actions. Be cautious of being deceived and avoiding
          unnecessary asset loss.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <ContainedButton
            variant="contained"
            sx={{
              width: "100%",
              textTransform: "initial",
            }}
            onClick={() => (
              handleUnderstand(), handleCloseWithdrawlCurrencyModal()
            )}
          >
            I Understand
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={sendModal}
        onClose={handleCloseSendModal}
        title={`Send ${currencyCode} ${tokentype?.toUpperCase()}`}
      >
        <Box
          sx={{
            mt: 2,
            textAlign: "justify",
            // backgroundColor: themeColor === "dark" ? "#31313a" : "#fff",
            px: 2,
            py: 2,
            width: "100%",
          }}
        >
          <Tabs
            value={sendTab}
            onChange={handleChangeSendTab}
            textColor="inherit"
            TabIndicatorProps={{
              style: { color: "var(--text-color)" },
            }}
            sx={{
              justifyContent: "space-between",
              display: "flex",
            }}
          >
            {[`${brokerBasicInfo?.companyName} WALLET`, "External Address"].map(
              (label, index) => (
                <Tab
                  key={label}
                  value={label}
                  label={
                    index === 1 ? (
                      <span>
                        {label}{" "}
                        <span
                          style={{ cursor: "pointer", paddingLeft: "10px" }}
                          onClick={() => setEnternalWalletInfo(true)}
                        >
                          {/* <i
                            className="fa fa-info-circle"
                            aria-hidden="true"
                          ></i> */}
                          <InfoIcon style={{ fontSize: "15px" }} />
                        </span>
                      </span>
                    ) : (
                      label
                    )
                  }
                  sx={{
                    flex: 1,
                    color: "var(--text-color)",
                    fontSize: "12px",
                  }}
                  onClick={() =>
                    sendTab === `${brokerBasicInfo?.companyName} WALLET`
                      ? getOtherWalletValuePol()
                      : getPolOtherWalletValue()
                  }
                />
              )
            )}
          </Tabs>

          <form onSubmit={handleSubmit(onSubmit)} style={{ padding: 0 }}>
            {sendTab === `${brokerBasicInfo?.companyName} WALLET` && (
              <Box sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid size={4}>
                    <p
                      className="text-end"
                      style={{ fontSize: "13px", padding: 0 }}
                    >
                      <span style={{ cursor: "pointer", marginRight: "10px" }}>
                        {/* <i
                            className="fa fa-info-circle"
                            aria-hidden="true"
                            onClick={() => setMobileNumberInfo(true)}
                          ></i> */}
                        <InfoIcon
                          style={{ fontSize: "15px" }}
                          onClick={() => setMobileNumberInfo(true)}
                        />
                      </span>
                      Receiver's Mobile No{" "}
                    </p>
                  </Grid>
                  <Grid size={8} sx={{ position: "relative" }}>
                    <div style={{ display: "flex" }}>
                      <div
                        onClick={() => setIsOpen(!isOpen)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "5px",
                          border: "1px solid black",
                          cursor: "pointer",
                          width: "60px",
                        }}
                      >
                        <img
                          src={selectedCountry?.flag || countryFlag[0]?.flag}
                          alt={selectedCountry?.code || countryFlag[0]?.code}
                        />
                      </div>
                      <input
                        type="number"
                        inputMode="numeric"
                        {...register("mobile", {
                          required: "Mobile number is required",
                          minLength: 6,
                        })}
                        className="beneficial_dropdown"
                        style={{ borderRadius: "0px" }}
                        onBlur={(e) => checkPhoneNumber(e.target.value)}
                      />
                    </div>
                    {errors.mobile && (
                      <p style={{ color: "red" }}>{errors.mobile.message}</p>
                    )}

                    {isOpen && (
                      <div
                        className="countryFlag"
                        style={{
                          position: "absolute",
                          top: "60px",
                          left: 0,
                          width: "300px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          background: "#000",
                          zIndex: 1000,
                          maxHeight: "200px",
                          overflowY: "auto",
                        }}
                      >
                        <input
                          type="text"
                          placeholder="Search country"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "10px",
                            border: "none",
                            borderBottom: "1px solid #ccc",
                            outline: "none",
                            backgroundColor: "black",
                            color: "white",
                          }}
                        />

                        {filteredCountries && filteredCountries?.length ? (
                          filteredCountries?.map((country) => (
                            <div
                              // key={country.value}
                              onClick={() => {
                                setSelectedCountry(country);
                                setIsOpen(false);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px",
                                cursor: "pointer",
                                background: "black",
                              }}
                            >
                              <img src={country.flag} alt={country.code} />
                              <span
                                style={{
                                  marginLeft: "10px",
                                  color: "#555",
                                }}
                              >
                                {country?.label}
                              </span>
                            </div>
                          ))
                        ) : (
                          <div style={{ padding: "10px", color: "#888" }}>
                            No results found
                          </div>
                        )}
                      </div>
                    )}
                  </Grid>

                  <Grid size={4} sx={{ textAlign: "end" }}>
                    <p style={{ fontSize: "13px" }}>Amount</p>
                  </Grid>
                  <Grid size={6}>
                    <input
                      type="number"
                      inputMode="numeric"
                      {...register("bitprimeAmount", {
                        required: "Amount is required",
                      })}
                      // value={paybitoAmount}
                      // onChange={(e) => setPaybitoAmount(e.target.value)}
                      className="beneficial_dropdown"
                      style={{ borderRadius: "0px" }}
                      onWheel={(e) => e.target.blur()}
                      onKeyUp={(e) => {
                        checkAmoutPrecision(
                          cryptoCurrency,
                          e.target.value,
                          "WALLET",
                          "walletAmount"
                        );
                        calculateFeeOnKeyUpForPaybitoWalletAmount(
                          e.target.value
                        );
                      }}
                    />
                    {errors.bitprimeAmount && (
                      <p style={{ color: "red" }}>
                        {errors.bitprimeAmount.message}
                      </p>
                    )}
                  </Grid>
                  <Grid
                    size={2}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ContainedButton
                      variant="contained"
                      sx={{
                        textTransform: "initial",
                        // mx: 0,
                        width: "100%",
                      }}
                      type="button"
                      disabled={maxDisable}
                      onClick={() => MaxSendAmountPaybitoWallet()}
                    >
                      Max
                    </ContainedButton>
                  </Grid>
                  <Grid size={4} sx={{ textAlign: "end" }}>
                    <span> Available Balance </span>
                  </Grid>
                  <Grid size={8}>
                    <span>
                      {" "}
                      {balance} {currencyCode} {tokentype?.toUpperCase()}
                    </span>
                  </Grid>

                  <Grid size={4} />
                  <Grid size={8}>
                    <ContainedButton
                      variant="contained"
                      sx={{
                        textTransform: "initial",
                      }}
                      // type="submit"
                      disabled={
                        !watch("bitprimeAmount") ||
                        watch("bitprimeAmount") > Number(maxWalletAmount) ||
                        !watch("mobile") ||
                        !(watch("bitprimeAmount") >= minValueCoin) ||
                        !(watch("bitprimeAmount") <= maxValueCoin)
                      }
                      onClick={() => checkforLockStatusWhileSendingToPaybito()}
                    >
                      Submit
                    </ContainedButton>
                  </Grid>
                </Grid>
                <div className="text-primary text-left mt-2">
                  {/* <h5>Estimated Network Fee {networkFee}</h5> */}
                  {/* {gstCharge > 0 && <h5>GST charges {gstCharge}</h5>} */}
                  {tdsCharge > 0 && <h5>TDS charges {tdsCharge}</h5>}
                </div>
                <small>
                  <small style={{ fontSize: "15px" }}>
                    Minimum of{" "}
                    <img
                      src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${currencyCode}.png`}
                      style={{ paddingRight: "5px", width: "20px" }}
                      alt=""
                    />
                    {minValueCoin} and Maximum{" "}
                    <img
                      src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${currencyCode}.png`}
                      style={{ paddingRight: "5px", width: "20px" }}
                      alt=""
                    />
                    {maxValueCoin} can be sent
                  </small>
                </small>
              </Box>
            )}

            {sendTab === "External Address" && (
              <Box sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid size={3} />
                  <Grid size={9}>
                    {withdrawWhiteEnableDisableStatus === 0 && (
                      <div className="d-flex">
                        <p
                          style={{
                            color: "#fff",
                            // textAlign: "center",
                            fontSize: "15px",
                            paddingRight: "10px",
                          }}
                        >
                          <Link
                            to="/settings"
                            // target="_blank"
                            style={{
                              color: "var(--text-color)",
                              textDecoration: "none",
                            }}
                          >
                            <i className="fa fa-ban" aria-hidden="true"></i>{" "}
                            Address Whitelist Disabled.{" "}
                            <span className="enable_text text-primary">
                              Enable.
                            </span>
                          </Link>
                        </p>
                      </div>
                    )}
                  </Grid>
                  {withdrawWhiteEnableDisableStatus === 0 ? (
                    <>
                      <Grid size={3} sx={{ textAlign: "end" }}>
                        <p
                          style={{
                            fontSize: "13px",
                            paddingTop: "10px",
                            // color: "gray",
                          }}
                        >
                          Receiver's Address
                        </p>
                      </Grid>
                      <Grid size={9}>
                        <RadioGroup
                          row
                          name="radio-address-group"
                          value={selectedAddressOption}
                          onChange={handleAddressOptionChange}
                        >
                          <FormControlLabel
                            value="Enter Address"
                            control={<Radio size="small" />}
                            label="Enter Address"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: "12px",
                                // color: "gray",
                              },
                            }}
                          />
                          <FormControlLabel
                            value="Choose Address"
                            control={<Radio size="small" />}
                            label="Choose Address"
                            sx={{
                              "& .MuiFormControlLabel-label": {
                                fontSize: "12px",
                                // color: "gray",
                              },
                            }}
                          />
                        </RadioGroup>
                      </Grid>
                    </>
                  ) : (
                    <>
                      <Grid size={3} />
                      <Grid
                        size={9}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <p className="text-success text-center p-2">
                          <i
                            className="fa fa-check-circle"
                            aria-hidden="true"
                          ></i>{" "}
                          Whitelist Enabled.
                        </p>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => setEnternalWalletInfo(true)}
                        >
                          {/* <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i> */}
                          <InfoIcon style={{ fontSize: "15px" }} />
                        </span>
                      </Grid>
                    </>
                  )}
                </Grid>

                <Grid container spacing={2}>
                  <Grid size={3} />

                  <Grid size={9}>
                    {selectedAddressOption === "Enter Address" ? (
                      <input
                        type="text"
                        {...register("externalInputAddress", {
                          required: "Address is required",
                        })}
                        className="beneficial_dropdown"
                        style={{ borderRadius: "0px" }}
                        onKeyUp={(e) => checkNodeaddress(e.target.value)}
                      />
                    ) : (
                      <select
                        {...register("externalSelectAddress", {
                          required: "Address is required",
                        })}
                        className="beneficial_dropdown"
                        onChange={(e) => {
                          const selectedAddress = e.target.value;
                          const data = whitelistAddressDetailsList.find(
                            (item) => item.address === selectedAddress
                          );
                          setValue("externalMemo", data?.memo || "");
                        }}
                      >
                        <option value="">Select any</option>
                        {whitelistAddressDetailsList?.length !== 0 ? (
                          whitelistAddressDetailsList?.map((data, i) => (
                            <option value={data?.address} key={i}>
                              {data?.address}
                            </option>
                          ))
                        ) : (
                          <option disabled>
                            No whitelisted address found for this asset
                          </option>
                        )}
                      </select>
                    )}
                    {errormsg && (
                      <p
                        className={
                          errormsg === "Valid address."
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {errormsg}
                      </p>
                    )}

                    {selectedAddressOption === "Choose Address" &&
                      whitelistAddressDetailsList.length === 0 &&
                      withdrawWhiteEnableDisableStatus !== 0 && (
                        <span>
                          No whitelisted address found for this asset{" "}
                          <a
                            onClick={() =>
                              navigate(
                                "/withdraw-address-whitelist/address-management"
                              )
                            }
                          >
                            [Whitelist addresses]
                          </a>{" "}
                          Or turn off the whitelist feature{" "}
                          <a onClick={() => navigate("/settings")} href="#">
                            [Turn off]
                          </a>
                        </span>
                      )}

                    {errors.externalInputAddress && (
                      <p style={{ color: "red" }}>
                        {errors.externalInputAddress.message}
                      </p>
                    )}
                    {errors.externalSelectAddress && (
                      <p style={{ color: "red" }}>
                        {errors.externalSelectAddress.message}
                      </p>
                    )}
                  </Grid>

                  {(memoRequired === 1 || cryptoCurrency == "HCX") && (
                    <>
                      <Grid size={3} sx={{ textAlign: "end" }}>
                        <p style={{ fontSize: "13px" }}>{currencyCode} Tag</p>
                      </Grid>

                      <Grid size={9}>
                        <input
                          type="number"
                          inputMode="numeric"
                          {...register("externalMemo", {
                            required: "This is required",
                          })}
                          className="beneficial_dropdown"
                          style={{ borderRadius: "0px" }}
                        />
                        {errors.externalMemo && (
                          <p style={{ color: "red" }}>
                            {errors.externalMemo.message}
                          </p>
                        )}
                      </Grid>
                    </>
                  )}

                  <Grid size={3} sx={{ textAlign: "end" }}>
                    <p style={{ fontSize: "13px" }}>Amount</p>
                  </Grid>
                  <Grid size={7}>
                    <input
                      type="number"
                      inputMode="numeric"
                      {...register("externalAmount", {
                        required: "Amount is required",
                      })}
                      className="beneficial_dropdown"
                      style={{ borderRadius: "0px" }}
                      onWheel={(e) => e.target.blur()}
                      onKeyUp={(e) => {
                        checkAmoutPrecision(
                          cryptoCurrency,
                          e.target.value,
                          "WALLET",
                          "exWallet"
                        );
                        calculateFeeOnKeyUpForPaybitoWalletAmount(
                          e.target.value
                        );
                        rate(e.target.value);
                      }}
                    />
                    {errors.externalAmount && (
                      <p style={{ color: "red" }}>
                        {errors.externalAmount.message}
                      </p>
                    )}
                  </Grid>
                  <Grid
                    size={2}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ContainedButton
                      variant="contained"
                      sx={{
                        textTransform: "initial",
                        width: "100%",
                      }}
                      type="button"
                      disabled={maxDisable}
                      onClick={() => MaxSendAmountExWallet()}
                    >
                      Max
                    </ContainedButton>
                  </Grid>
                  <Grid size={3} sx={{ textAlign: "end" }}>
                    <span> Available Balance </span>
                  </Grid>
                  <Grid size={9}>
                    <span> {balance}</span>
                  </Grid>

                  <Grid size={3} />
                  <Grid size={9}>
                    <ContainedButton
                      variant="contained"
                      sx={{
                        textTransform: "initial",
                      }}
                      // type="submit"
                      disabled={isDisable()}
                      onClick={() => checkUserHasGeneratedAddress()}
                    >
                      Submit
                    </ContainedButton>
                  </Grid>

                  <Grid size={12} sx={{ color: "white" }}>
                    <h5 className="text-primary ">
                      Estimated Network Fee {networkFee}
                    </h5>
                    {gstCharge > 0 && (
                      <h5 className="text-primary ">GST charges {gstCharge}</h5>
                    )}
                    {tdsCharge > 0 && (
                      <h5 className="text-primary ">TDS charges {tdsCharge}</h5>
                    )}
                    <small className="text-primary">
                      <small style={{ fontSize: "15px" }}>
                        Minimum of{" "}
                        <img
                          src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${currencyCode}.png`}
                          style={{ paddingRight: "5px", width: "20px" }}
                          alt=""
                        />
                        {minValueCoin} and Maximum{" "}
                        <img
                          src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${currencyCode}.png`}
                          style={{ paddingRight: "5px", width: "20px" }}
                          alt=""
                        />
                        {maxValueCoin} can be sent
                      </small>
                    </small>
                    <p
                      className={`pt-3 `}
                      style={{ color: "var(--text-color)" }}
                    >
                      Notice: For the safety of your assets, please make sure
                      the transfer network is{" "}
                      {tokentype === "ERC"
                        ? "ERC 20"
                        : tokentype === "BSC"
                        ? "BEP 20"
                        : tokentype === "NATIVE"
                        ? currencyCode
                        : tokentype === "POL"
                        ? "POL"
                        : tokentype
                        ? `${currencyCode} ${tokentype}`
                        : ERCCURRENCY.includes(currencyId)
                        ? "ERC 20"
                        : currencyCode}
                      . If the network does not match, your assets will be lost
                      and cannot be recovered.
                    </p>
                  </Grid>
                </Grid>
              </Box>
            )}
          </form>
        </Box>
      </ModalContent>

      <ModalContent
        open={depositeCurrencyModal}
        onClose={handleDepositeCurrencyModal}
        title={`Deposit ${currencyCode}`}
      >
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            textAlign: "justify",
            // color: "gray",
            // backgroundColor: themeColor === "dark" ? "#31313a" : "#fff",
            px: 4,
            py: 2,
            width: "100%",
            textAlign: "center",
          }}
        >
          <img
            alt={currencyCode}
            src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${currencyCode}.png`}
            style={{ width: "40px", height: "40px", marginBottom: "10px" }}
          />
          <h3>{`Only send ${currencyFullName} (${currencyCode}) to this address`}</h3>
          <p>Sending any other cryptocurrency will result in permanent loss</p>
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <ContainedButton
            variant="contained"
            sx={{
              width: "100%",
              textTransform: "initial",
            }}
            onClick={() => (
              handleUnderstandDeposite(), handleDepositeCurrencyModal()
            )}
          >
            I Understand
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={depositeModal}
        onClose={handleCloseDepositeModal}
        title={`Receive code for ${currencyCode} ${
          !isHCX && showERC ? tokentype.toLocaleUpperCase() : ""
        }`}
      >
        <Box
          variant="body1"
          sx={{
            mt: 2,
            textAlign: "justify",
            // color: "gray",
            // backgroundColor: themeColor === "dark" ? "#31313a" : "#fff",
            px: 4,
            py: 2,
            width: "100%",
            textAlign: "center",
          }}
        >
          {rcv === null ? (
            <i className="fa fa-circle-o-notch fa-spin fa-5x fa-fw text-center" />
          ) : (
            <>
              {coinTag && (
                <Box mb={2}>
                  <Typography variant="subtitle1">
                    {cryptoCurrency.toUpperCase()} Tag
                  </Typography>
                  <input
                    type="text"
                    className="beneficial_dropdown"
                    style={{
                      borderRadius: "0px",
                      backgroundColor: "#282e40",
                    }}
                    value={coinTag}
                    readOnly
                  />
                  <ContainedButton
                    variant="contained"
                    sx={{
                      display: "block",
                      mx: "auto",
                      my: 2,
                    }}
                    onClick={handleCopyTag}
                  >
                    Copy
                  </ContainedButton>
                </Box>
              )}

              <input
                type="text"
                className="beneficial_dropdown"
                style={{ borderRadius: "0px", backgroundColor: "#282e40" }}
                value={rcv}
                readOnly
              />
              <ContainedButton
                variant="contained"
                sx={{
                  display: "block",
                  mx: "auto",
                  my: 2,
                }}
                onClick={() => handleCopy(rcv)}
              >
                Copy
              </ContainedButton>
              <QRCode
                value={rcv}
                style={{ height: "100%" }}
                level="M"
                className="d-block mx-auto my-2"
              />
              <p className={`pt-3 `} style={{ color: "var(--text-color)" }}>
                Notice: For the safety of your assets, please make sure the
                transfer network is{" "}
                {tokentype === "ERC"
                  ? "ERC 20"
                  : tokentype === "BSC"
                  ? "BEP 20"
                  : tokentype === "NATIVE"
                  ? currencyCode
                  : tokentype === "POL"
                  ? "POL"
                  : tokentype
                  ? `${currencyCode} ${tokentype}`
                  : ERCCURRENCY.includes(currencyId)
                  ? "ERC 20"
                  : currencyCode}
                . If the network does not match, your assets will be lost and
                cannot be recovered.
              </p>
            </>
          )}
        </Box>
      </ModalContent>

      <InfoPopUp
        open={showMobileNumberInfo}
        onClose={() => setMobileNumberInfo(false)}
        title={`${brokerBasicInfo?.exchange} Wallet`}
        description={`You can send asset from ${brokerBasicInfo?.exchange} wallet to ${brokerBasicInfo?.exchange} wallet through a users registered mobile number`}
      />

      <InfoPopUp
        open={showEnternalWalletInfo}
        onClose={() => setEnternalWalletInfo(false)}
        title={`External Wallet`}
        description={`You can send asset from ${brokerBasicInfo?.exchange} wallet to an External address`}
      />

      <InfoPopUp
        open={showWalletTnxHModal}
        onClose={() => setWalletTnxHModal(false)}
        title={`Wallet Transactions History`}
        description={`Wallet Transactions History displays the send receive of cryptocurrency.`}
      />

      <InfoPopUp
        open={infoModal}
        onClose={handleCloseInfoModal}
        title={Infomodal[infoIndex]?.title}
        description={Infomodal[infoIndex]?.description}
      />

      <ModalContent open={currencyMiddleModal} onClose={handleCloseMiddleModal}>
        <Box
          sx={{
            mt: 4,
            textAlign: "justify",
            // color: "gray",
            // backgroundColor: themeColor === "dark" ? "#31313a" : "#fff",
            px: 4,
            py: 2,
            width: "100%",
            textAlign: "center",
          }}
        >
          {options?.map((d, i) => (
            <>
              <p className="pb-1">{d.message}</p>
              <h5
                className={` currenLabel`}
                onClick={() =>
                  getCurrencyForRecieveNative(
                    currencyCode,
                    currencyId,
                    d?.handlerKey
                  )
                }
              >
                {d.label}
              </h5>
            </>
          ))}
        </Box>
      </ModalContent>

      <ModalContent
        open={currencyMiddleSendModal}
        onClose={handleCloseMiddleSendModal}
        title={" "}
      >
        <Box
          sx={{
            mt: 4,
            textAlign: "justify",
            // color: "gray",
            // backgroundColor: themeColor === "dark" ? "#31313a" : "#fff",
            px: 4,
            py: 2,
            width: "100%",
            textAlign: "center",
          }}
        >
          {optionsSend?.map((d, i) => (
            <>
              <p className="pb-1">{d.message}</p>

              <h5
                className={` currenLabel`}
                onClick={() =>
                  getCurrencyForSendNative(
                    currencyCode,
                    currencyId,
                    d?.handlerKey
                  )
                }
              >
                {d.label}
              </h5>
            </>
          ))}
        </Box>
      </ModalContent>

      <ModalContent
        open={authModalOpen}
        onClose={handleCloseAuthModal}
        title={`Security Authentication`}
      >
        <Typography
          sx={{
            mb: 1,
          }}
        >
          Input OTP from your registered email address
        </Typography>
        <Grid container spacing={1} alignItems="center">
          <Grid size={!timer ? 8 : 12}>
            <TextField
              fullWidth
              type="number"
              variant="outlined"
              autoComplete="off"
              placeholder="OTP"
              value={emailOtp}
              onChange={(e) => {
                if (e.target.value.length <= 8) setEmailOtp(e.target.value);
              }}
              onWheel={(e) => e.target.blur()}
              autoFocus
              inputProps={{ maxLength: 8 }}
              InputProps={{}}
            />
          </Grid>
          {!timer && (
            <Grid size={4}>
              <ContainedButton
                variant="contained"
                fullWidth
                sx={{ height: "55px" }}
                onClick={getCodeFromEmail}
                // disabled={isGetCodeButtonDisabled}
              >
                Get Code
              </ContainedButton>
            </Grid>
          )}
        </Grid>

        {timer && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Resend OTP in {emailOtpTime} seconds
          </Typography>
        )}

        <TextField
          fullWidth
          type="number"
          variant="outlined"
          autoComplete="off"
          placeholder="Two-Factor Authenticator code"
          value={twoFactorOtp}
          onChange={(e) => {
            if (e.target.value.length <= 6) setTwoFactorOtp(e.target.value);
          }}
          onWheel={(e) => e.target.blur()}
          sx={{ mt: 2 }}
          inputProps={{ maxLength: 6 }}
          InputProps={{}}
        />

        {/* Confirm Buttons */}
        <Box sx={{ mt: 3 }}>
          <ContainedButton
            variant="contained"
            fullWidth
            disabled={!twoFactorOtp || !emailOtp || isConfirmLoading}
            onClick={handleConfirm}
          >
            {isConfirmLoading ? "Please wait..." : "Confirm"}
          </ContainedButton>
        </Box>
      </ModalContent>

      <ModalContent
        open={questionModal}
        onClose={() => setShowQuestionModal(false)}
        title={`Transfer Details`}
      >
        <Box>
          <Typography variant="h6" align="center">
            Additional Info Required
          </Typography>
          <Typography
            variant="body2"
            align="justify"
            sx={{ color: "text.secondary" }}
          >
            We are mandated by regulators to collect these records. If we do not
            maintain these records, we will not be able to operate in your
            region and offer you services legally. The information you are
            providing here shall only be used for regulatory record keeping
            purposes and for no other reason.
          </Typography>

          <Box component="form" onSubmit={submitQuestions} mt={2}>
            <Typography>Transferring to an account you own?</Typography>
            <FormControlLabel
              control={
                <Checkbox checked={ownAccount} onChange={ownAccountCheck} />
              }
              label="Yes, I own this account"
            />

            <Box mt={2}>
              <Typography>Select recipient entity</Typography>
              <RadioGroup
                value={
                  individualCheck ? "Individual" : companyCheck ? "Company" : ""
                }
                onChange={selctKycUserType}
              >
                <FormControlLabel
                  value="Individual"
                  control={<Radio disabled={ownAccount} />}
                  label="Individual"
                />
                <FormControlLabel
                  value="Company"
                  control={<Radio disabled={ownAccount} />}
                  label="Company"
                />
              </RadioGroup>
            </Box>

            <Box display="flex" gap={2} mt={2}>
              <TextField
                fullWidth
                label={`${
                  individualCheck
                    ? "First name of the originator"
                    : companyCheck
                    ? "Legal name of the originating enterprise "
                    : ""
                }`}
                placeholder="Enter name"
                inputProps={{
                  maxLength: individualCheck ? 50 : companyCheck ? 100 : null,
                }}
                value={recipientFirstName}
                onChange={(e) => setRecipientFirstName(e.target.value)}
                InputProps={{
                  readOnly: ownAccount,
                }}
              />
              {individualCheck && (
                <TextField
                  fullWidth
                  label={`${
                    individualCheck ? "Last name of the originator" : ""
                  }`}
                  placeholder="Enter last name"
                  inputProps={{ maxLength: 50 }}
                  value={recipientLastName}
                  onChange={(e) => setRecipientLastName(e.target.value)}
                  InputProps={{
                    readOnly: ownAccount,
                  }}
                />
              )}
            </Box>

            <Typography sx={{ py: 2 }}>
              What is the account number or their customer number or unique
              identifier of the recipient in the exchange or wallet you are
              making the transfer to? (If you do not know this, ask the
              recipient to provide you with this info).*
            </Typography>

            <TextField
              fullWidth
              label="Account/customer/unique identifier"
              placeholder="Enter identifier"
              inputProps={{ maxLength: 50 }}
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              // sx={{ mt: 2 }}
            />

            <Typography sx={{ py: 2 }}>
              Kindly provide us with an email address for the crypto firm where
              this recipient holds the account?*
            </Typography>

            <TextField
              fullWidth
              label="Crypto firm's email address"
              placeholder="Enter email address"
              inputProps={{ maxLength: 50 }}
              value={cryptoEmailAddress}
              onChange={(e) => setCryptoEmailAddress(e.target.value)}
              // sx={{ mt: 2 }}
            />

            <FormControlLabel
              control={
                <Checkbox onChange={termsCheck} sx={{ paddingTop: "3px" }} />
              }
              label={
                <Box>
                  <Typography variant="body1" fontWeight="bold">
                    I agree to the terms below
                  </Typography>
                  <Typography variant="body2">
                    By sending this transfer you agree to share your personal
                    information ({checkBoxText()}) with the receiving exchange.
                  </Typography>
                </Box>
              }
              sx={{ mt: 2, alignItems: "flex-start" }}
            />

            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <ContainedButton
                type="submit"
                variant="contained"
                disabled={isTermsChecked}
              >
                Submit
              </ContainedButton>
            </Box>
          </Box>
        </Box>
      </ModalContent>

      <ModalContent
        open={questionModalRecieve}
        onClose={() => setShowQuestionModalRecieve(false)}
        title={`Transfer Details`}
      >
        <Box mb={3}>
          <Typography variant="h5" align="center" gutterBottom>
            Additional Info Required
          </Typography>
          <Typography
            variant="body2"
            align="justify"
            sx={{ color: "text.secondary" }}
          >
            We are mandated by regulators to collect these records. If we do not
            maintain these records, we will not be able to operate in your
            region and offer you services legally. The information you are
            providing here shall only be used for regulatory record keeping
            purposes and for no other reason.
          </Typography>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              submitQuestionsRcv();
            }}
          >
            {/* Own Account Checkbox */}
            <Typography>Transferring from an account you own?</Typography>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox onChange={ownAccountCheckRcv} />}
                label="Yes, I own this account"
              />
            </FormGroup>

            {/* Originating Entity Radio Buttons */}
            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <FormLabel component="legend">
                Select originating entity
              </FormLabel>
              <RadioGroup
                row
                name="inlineRadioOptionsjjjj"
                value={
                  individualCheckRcv
                    ? "Individual"
                    : companyCheckRcv
                    ? "Company"
                    : ""
                }
                onChange={selctKycUserTypeRcv}
              >
                <FormControlLabel
                  value="Individual"
                  control={<Radio disabled={ownAccountRcv} />}
                  label="Individual"
                />
                <FormControlLabel
                  value="Company"
                  control={<Radio disabled={ownAccountRcv} />}
                  label="Company"
                />
              </RadioGroup>
            </FormControl>

            {/* Recipient Names */}
            <Box display="flex" gap={2} mt={2}>
              <TextField
                fullWidth
                label={`${
                  individualCheckRcv
                    ? "First name of the originator"
                    : companyCheckRcv
                    ? "Legal name of the originating enterprise "
                    : ""
                }`}
                placeholder="Enter name"
                inputProps={{ maxLength: 50 }}
                value={recipientFirstNameRcv}
                onChange={(e) => setRecipientFirstNameRcv(e.target.value)}
                name="recipientFirstName"
                InputProps={{
                  readOnly: ownAccountRcv,
                }}
              />

              {individualCheckRcv && (
                <TextField
                  fullWidth
                  label={`${
                    individualCheckRcv ? "Last name of the originator" : ""
                  }`}
                  placeholder="Enter name"
                  inputProps={{ maxLength: 50 }}
                  value={recipientLastNameRcv}
                  onChange={(e) => setRecipientLastNameRcv(e.target.value)}
                  name="recipientLastName"
                  InputProps={{
                    readOnly: ownAccountRcv,
                  }}
                />
              )}
            </Box>

            {/* Account Number */}
            <FormLabel component="legend" sx={{ my: 2 }}>
              What is the account number or their customer number or unique
              identifier of the originator in the exchange or wallet you are
              making the transfer from? (If you do not know this, ask the
              originator to provide you with this info).*
            </FormLabel>

            <TextField
              fullWidth
              label="Account number/Customer number/Unique identifier"
              inputProps={{ maxLength: 50 }}
              value={accountNumberRcv}
              onChange={(e) => setAccountNumberRcv(e.target.value)}
              name="accountNumber"
            />

            {/* Individual Flag Radio Options */}
            {individualFlag && (
              <FormControl component="fieldset" sx={{ mt: 2 }}>
                <FormLabel component="legend">
                  Please provide the originator's address or passport or
                  national ID number or date and place of birth as registered on
                  the originating exchange or wallet.
                  <br />I am providing
                </FormLabel>
                <RadioGroup
                  name="inlineRadioOptions"
                  defaultValue="addr"
                  onChange={changeUserProvide}
                >
                  <FormControlLabel
                    value="addr"
                    control={<Radio />}
                    label="Originator's address"
                  />
                  <FormControlLabel
                    value="passport"
                    control={<Radio />}
                    label="Originator's Passport or national ID number"
                  />
                  <FormControlLabel
                    value="birthPlace"
                    control={<Radio />}
                    label="Originator's Date of birth and place of birth"
                  />
                </RadioGroup>
              </FormControl>
            )}

            {/* Company Flag Radio Options */}
            {companyFlag && (
              <FormControl component="fieldset" sx={{ mt: 2 }}>
                <FormLabel component="legend">
                  Please provide the originator's address or passport or
                  national ID number or date and place of birth as registered on
                  the originating exchange or wallet.
                  <br />I am providing
                </FormLabel>
                <RadioGroup
                  name="inlineRadioOptions"
                  defaultValue="idNumber"
                  onChange={changeUserProvideEnt}
                >
                  <FormControlLabel
                    value="idNumber"
                    control={<Radio />}
                    label="Company identification number"
                  />
                  <FormControlLabel
                    value="originator"
                    control={<Radio />}
                    label="Principal place of business of the originator enterprise"
                  />
                </RadioGroup>
              </FormControl>
            )}

            {/* Address Fields */}
            {addressFlag && (
              <Box display="flex" flexWrap="wrap" gap={2} mt={2}>
                <TextField
                  label="House no./Apt no."
                  inputProps={{ maxLength: 50 }}
                  value={houseNoVal}
                  onChange={(e) => setHouseNoVal(e.target.value)}
                  sx={{ flex: "1 1 45%" }}
                />
                <TextField
                  label="Street/Area"
                  inputProps={{ maxLength: 50 }}
                  value={streetVal}
                  onChange={(e) => setStreetVal(e.target.value)}
                  sx={{ flex: "1 1 45%" }}
                />
                <TextField
                  label="City"
                  inputProps={{ maxLength: 50 }}
                  value={cityVal}
                  onChange={(e) => setCityVal(e.target.value)}
                  sx={{ flex: "1 1 45%" }}
                />
                <TextField
                  label="State"
                  inputProps={{ maxLength: 50 }}
                  value={stateVal}
                  onChange={(e) => setStateVal(e.target.value)}
                  sx={{ flex: "1 1 45%" }}
                />
                <FormControl sx={{ flex: "1 1 45%" }}>
                  {/* <FormLabel>Country</FormLabel> */}
                  <Select
                    value={countryVal}
                    onChange={(e) => setCountryVal(e.target.value)}
                    displayEmpty
                    // size="small"
                    // sx={{}}
                  >
                    <MenuItem value="">Select Country</MenuItem>
                    {countryList.map((country, i) => (
                      <MenuItem key={i} value={country?.name}>
                        {country?.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  label="Zip Code/Pin Code"
                  inputProps={{ maxLength: 10 }}
                  value={zipVal}
                  onChange={(e) => setZipVal(e.target.value)}
                  onKeyDown={OnlyAllowedZipCode}
                  sx={{ flex: "1 1 45%" }}
                />
              </Box>
            )}

            {/* Passport */}
            {passportFlag && (
              <TextField
                fullWidth
                label="Please enter passport or national id *"
                inputProps={{ maxLength: 30 }}
                value={passportVal}
                onChange={(e) => setPassportVal(e.target.value)}
                sx={{ mt: 2 }}
              />
            )}

            {/* Birth Date and Place */}
            {birthFlag && (
              <Box display="flex" gap={2} mt={2}>
                <TextField
                  label="Date Of birth*"
                  type="date"
                  value={indDobVal}
                  onChange={(e) => setIndDobVal(e.target.value)}
                  sx={{ flex: "1 1 45%" }}
                  InputLabelProps={{ shrink: true }}
                  name="dob"
                />
                <TextField
                  label="Place of birth*"
                  inputProps={{ maxLength: 50 }}
                  value={indPobVal}
                  onChange={(e) => setIndPobVal(e.target.value)}
                  sx={{ flex: "1 1 45%" }}
                  name="pob"
                />
              </Box>
            )}

            {/* Company ID Number */}
            {idNumberVal && (
              <TextField
                fullWidth
                label="Company identification number *"
                value={comIdNum}
                onChange={(e) => setComIdNum(e.target.value)}
                sx={{ mt: 2 }}
              />
            )}

            {/* Principal Place of Business */}
            {originatorval && (
              <TextField
                fullWidth
                label="Principal place of business of the originator enterprise *"
                value={bsnsLoc}
                onChange={(e) => setBsnsLoc(e.target.value)}
                sx={{ mt: 2 }}
              />
            )}

            {/* Crypto Firm Email */}
            <FormLabel component="legend" sx={{ my: 2 }}>
              Please let us know the email address of the originator crypto firm
              [the crypto exchange, wallet or trading platform where the crypto
              was withdrawn from]*
            </FormLabel>
            <TextField
              fullWidth
              label="Email address of the originator crypto firm"
              inputProps={{ maxLength: 50 }}
              value={cryptoFirmRcv}
              onChange={(e) => setCryptoFirmRcv(e.target.value)}
              // sx={{ mt: 2 }}
            />

            {/* Terms Checkbox */}
            <FormGroup sx={{ mt: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={termsCheckRcv}
                    sx={{ paddingTop: "3px" }}
                  />
                }
                label={
                  <>
                    <Typography component="span" fontWeight="bold">
                      I agree to the terms below
                    </Typography>
                    {/* <Typography variant="caption" display="block">
                        By receiving this transfer you agree to share your
                        personal information ({checkBoxText()}) with the
                        originating exchange.
                      </Typography> */}
                    <Typography variant="caption" display="block">
                      The info you have filled in this form will be shared with
                      the originating crypto firm.
                    </Typography>
                  </>
                }
                sx={{ mt: 2, alignItems: "flex-start" }}
              />
            </FormGroup>

            {/* Submit Button */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <ContainedButton
                type="submit"
                variant="contained"
                disabled={rcvButtonStatus}
                fullWidth
              >
                Submit
              </ContainedButton>
            </Box>
          </form>
        </Box>
      </ModalContent>

      <ModalContent
        open={warningPopupSendModal}
        onClose={() => setWarningPopupSendModal(false)}
        title={`Warning`}
      >
        <Box display="flex" justifyContent="center">
          <Typography variant="h4" component="div" color="warning.main">
            {/* <i
                class="fa fa-exclamation-triangle warning-notice"
                style={{
                  color: themeColor === "dark" ? "" : "black",
                  fontSize: "80px",
                }}
                aria-hidden="true"
              ></i> */}
            <WarningAmberIcon
              className="warning-notice"
              style={{
                color: themeColor === "dark" ? "" : "black",
                fontSize: "80px",
              }}
            />
          </Typography>
        </Box>

        <Box className="row" mt={2}>
          <Typography
            className={themeColor === "dark" ? "text-white" : "text-dark"}
            sx={{
              textAlign: "justify",
              px: 4,
              color: themeColor === "dark" ? "#ffffff" : "#000",
            }}
          >
            You have received one or more assets in your{" "}
            {brokerBasicInfo?.exchange} Wallet. But these assets are not yet
            available for your use. Please go to the Wallet Transaction History
            (receive tab) on this page below and click on the yellow alert sign
            in the "Travel Rule info" column for each transaction. Kindly answer
            the questions that appear in the form. Our team will review the
            answers and process your deposit. This is a regulatory requirement.
          </Typography>
        </Box>
      </ModalContent>

      <ModalContent
        open={warningPopupModal}
        onClose={() => setWarningPopupModal(false)}
        title={`Warning`}
      >
        <Box display="flex" justifyContent="center">
          <Typography variant="h4" component="div" color="warning.main">
            {/* <i
                class="fa fa-exclamation-triangle warning-notice"
                style={{
                  color: themeColor === "dark" ? "" : "black",
                  fontSize: "80px",
                }}
                aria-hidden="true"
              ></i> */}
            <WarningAmberIcon
              className="warning-notice"
              style={{
                color: themeColor === "dark" ? "" : "black",
                fontSize: "80px",
              }}
            />
          </Typography>
        </Box>

        <Box className="row" mt={2}>
          <Typography
            className={themeColor === "dark" ? "text-white" : "text-dark"}
            sx={{
              textAlign: "justify",
              px: 4,
              color: themeColor === "dark" ? "#ffffff" : "#000",
            }}
          >
            You have withdrawn one or more assets from your{" "}
            {brokerBasicInfo?.exchange} Wallet. But the withdrawal is pending.
            Please go to the Wallet Transaction History (send tab) on this page
            below and click on the yellow alert sign in the "Travel Rule info"
            column for your transaction(s). Kindly answer the questions that
            appear in the form. Our team will review the answers and process
            your withdrawal. This is a regulatory requirement.
          </Typography>
        </Box>
      </ModalContent>

      <ModalContent
        open={warningPopupGenModal}
        onClose={() => setWarningPopupGenModal(false)}
        title={`Warning`}
      >
        <Box display="flex" justifyContent="center">
          <Typography variant="h4" component="div" color="warning.main">
            {/* <i
                class="fa fa-exclamation-triangle warning-notice"
                style={{
                  color: themeColor === "dark" ? "" : "black",
                  fontSize: "80px",
                }}
                aria-hidden="true"
              ></i> */}
            <WarningAmberIcon
              className="warning-notice"
              style={{
                color: themeColor === "dark" ? "" : "black",
                fontSize: "80px",
              }}
            />
          </Typography>
        </Box>

        <Box className="row" mt={2}>
          <Typography
            className={themeColor === "dark" ? "text-white" : "text-dark"}
            sx={{
              textAlign: "justify",
              px: 4,
              color: themeColor === "dark" ? "#ffffff" : "#000",
            }}
          >
            You have received and withdrawn one or more assets from your{" "}
            {brokerBasicInfo?.exchange} Wallet. But these transactions are
            pending. Please go to the Wallet Transaction History on this page
            below. Click on send tab to see your crypto withdrawals and receive
            tab to see your crypto deposits. Click on the yellow alert sign in
            the "Travel Rule info" column for each of your transactions. Kindly
            answer the questions that appear in the form. Our team will review
            the answers and process your transaction. This is a regulatory
            requirement.
          </Typography>
        </Box>
      </ModalContent>

      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={localStorage.getItem("theme")}
      />

      <PabtekPaymentPopup
        open={pabtekPopupOpen}
        onClose={() => setPabtekPopupOpen(false)}
        currencyId={pabtekCurrency.id}
        currencyCode={pabtekCurrency.code}
        userUuid={localStorage.getItem("uuid") || ""}
        theme={localStorage.getItem("theme") || "light"}
      />
    </Box>
  );
};

// ── Design System Styles ──────────────────────────────────────────────────────
const pageWrapper = {
  px: { xs: 2, md: 4 },
  py: { xs: 2, md: 3 },
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "calc(100vh - 64px)",
};

const heroBanner = {
  borderRadius: "18px",
  px: { xs: 3, md: 4 },
  py: { xs: 3, md: 3.5 },
  mb: 3,
  position: "relative",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
};

const heroContent = {
  display: "flex",
  alignItems: "center",
  gap: 2,
  position: "relative",
  zIndex: 1,
};

const heroIconBadge = {
  width: 56,
  height: 56,
  borderRadius: "14px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.18)",
  border: "1px solid rgba(255,255,255,0.25)",
  backdropFilter: "blur(6px)",
  flexShrink: 0,
};

const heroTitle = {
  fontSize: { xs: "1.4rem", md: "1.7rem" },
  fontWeight: 700,
  color: "#fff",
  lineHeight: 1.15,
  letterSpacing: "-0.015em",
};

const heroSubtitle = {
  fontSize: { xs: "0.82rem", md: "0.9rem" },
  color: "rgba(255,255,255,0.88)",
  mt: 0.5,
  maxWidth: 640,
};

const mainCard = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const tableHeaderRow = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: { xs: 2, md: 2.5 },
  py: 2,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
};

const cardSectionTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  letterSpacing: "-0.01em",
};

const cardSectionCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.6,
  mt: 0.25,
};

const searchFieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontSize: "0.83rem",
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    "& fieldset": { borderColor: "rgba(125,125,125,0.25)" },
    "&:hover fieldset": { borderColor: "rgba(125,125,125,0.45)" },
    "&.Mui-focused fieldset": { borderColor: "var(--text-color)" },
  },
  "& .MuiInputBase-input::placeholder": {
    color: "var(--text-color)",
    opacity: 0.5,
  },
  minWidth: 200,
};

const modernTableContainer = {
  maxHeight: 520,
  overflowX: "auto",
};

const tableStyle = {
  minWidth: 650,
};

const modernTableHeadRow = {
  backgroundColor: "var(--body-color-less2)",
};

const modernTableHeadCell = {
  fontWeight: 700,
  fontSize: "0.72rem",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
  color: "var(--text-color)",
  opacity: 0.75,
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  py: 1.75,
  whiteSpace: "nowrap",
  backgroundColor: "var(--body-color-less2)",
};

const modernTableBodyRow = {
  transition: "background-color 0.15s ease",
  "&:hover": { backgroundColor: "var(--body-color-less2)" },
  "&:last-child td": { borderBottom: 0 },
};

const modernTableBodyCell = {
  fontSize: "0.85rem",
  py: 1.65,
  borderBottom: "1px solid rgba(125,125,125,0.12)",
  color: "var(--text-color)",
  whiteSpace: "nowrap",
};
// ─────────────────────────────────────────────────────────────────────────────

export default MyWalletSpot;
